export default {
  remetente_destinatario: {
    id_tipo_filtro: "1",
    descricao: "remetente/destinatario",
    tipo_campo: "select",
    html_id: "remetente_destinatario",
    dependencia_count: "0",
    valores: []
  },
  destinacao: {
    id_tipo_filtro: "3",
    descricao: "destinação",
    tipo_campo: "select",
    html_id: "destinacao",
    dependencia_count: "0",
    valores: [
      {
        id_filtro: 23,
        id_tipo_filtro: "3",
        descricao: "Ativo Imobilizado",
        legenda: "ativo",
        descricao_importador: "Ativo por não contribuinte do icms",
        exibe_cenario: "1",
        value: "23",
        label: "Ativo Imobilizado"
      },
      {
        id_filtro: 24,
        id_tipo_filtro: "3",
        descricao: "Ativo Imobilizado",
        legenda: "ativoicms",
        descricao_importador: "Ativo por contribuinte do icms",
        exibe_cenario: "1",
        value: "24",
        label: "Ativo Imobilizado"
      },
      {
        id_filtro: 27,
        id_tipo_filtro: "3",
        descricao: "Consumo Final",
        legenda: "consumo",
        descricao_importador: "Consumo por pessoa física ou instituição sem regime tributário",
        exibe_cenario: "1",
        value: "27",
        label: "Consumo Final"
      },
      {
        id_filtro: 19,
        id_tipo_filtro: "3",
        descricao: "Insumo",
        legenda: "ins",
        descricao_importador: "Insumo",
        exibe_cenario: "1",
        value: "19",
        label: "Insumo"
      },
      {
        id_filtro: 20,
        id_tipo_filtro: "3",
        descricao: "Revenda",
        legenda: "revenda",
        descricao_importador: "Revenda",
        exibe_cenario: "1",
        value: "20",
        label: "Revenda"
      },
      {
        id_filtro: 26,
        id_tipo_filtro: "3",
        descricao: "Uso ou consumo",
        legenda: "usoicms",
        descricao_importador: "Uso/consumo por contribuinte do icms",
        exibe_cenario: "1",
        value: "26",
        label: "Uso ou consumo"
      },
      {
        id_filtro: 25,
        id_tipo_filtro: "3",
        descricao: "Uso ou consumo",
        legenda: "uso",
        descricao_importador: "Uso/consumo por não contribuinte do icms",
        exibe_cenario: "1",
        value: "25",
        label: "Uso ou consumo"
      },
      {
        id_filtro: 21,
        id_tipo_filtro: "3",
        descricao: "Utilização na Prestação de Serviço Sujeita ao ICMS",
        legenda: "uicms",
        descricao_importador: "Utilização na prestação de serviço sujeita ao ICMS",
        exibe_cenario: "1",
        value: "21",
        label: "Utilização na Prestação de Serviço Sujeita ao ICMS"
      },
      {
        id_filtro: 22,
        id_tipo_filtro: "3",
        descricao: "Utilização na Prestação de Serviço Sujeita ao ISS",
        legenda: "uiss",
        descricao_importador: "Utilização na prestação de serviço sujeita ao ISSQN",
        exibe_cenario: "1",
        value: "22",
        label: "Utilização na Prestação de Serviço Sujeita ao ISS"
      }
    ]
  },
  regime_tributacao: {
    id_tipo_filtro: "4",
    descricao: "regime de tributação",
    tipo_campo: "select",
    html_id: "regime_tributacao",
    dependencia_count: "0",
    valores: [
      {
        id_filtro: 30,
        id_tipo_filtro: "4",
        descricao: "Cumulativo (Lucro Real/Presumido)",
        legenda: "1",
        descricao_importador: "Cumulativo (Lucro Real/Presumido)",
        exibe_cenario: "1",
        value: "30",
        label: "Cumulativo (Lucro Real/Presumido)"
      },
      {
        id_filtro: 33,
        id_tipo_filtro: "4",
        descricao: "Imune/Isenta",
        legenda: "4",
        descricao_importador: "Imune/Isenta",
        exibe_cenario: "1",
        value: "33",
        label: "Imune/Isenta"
      },
      {
        id_filtro: 31,
        id_tipo_filtro: "4",
        descricao: "Não Cumulativo (Lucro Real)",
        legenda: "2",
        descricao_importador: "Não Cumulativo (Lucro Real)",
        exibe_cenario: "1",
        value: "31",
        label: "Não Cumulativo (Lucro Real)"
      },
      {
        id_filtro: 28,
        id_tipo_filtro: "4",
        descricao: "Sem Regime Tributário",
        legenda: "0",
        descricao_importador: "Sem Regime Tributário",
        exibe_cenario: "1",
        value: "28",
        label: "Sem Regime Tributário"
      },
      {
        id_filtro: 32,
        id_tipo_filtro: "4",
        descricao: "Simples Nacional",
        legenda: "3",
        descricao_importador: "Simples Nacional",
        exibe_cenario: "1",
        value: "32",
        label: "Simples Nacional"
      }
    ]
  },
  exibicao: {
    id_tipo_filtro: "5",
    descricao: "exibição",
    tipo_campo: "select",
    html_id: "exibicao",
    dependencia_count: "0",
    valores: [
      {
        id_filtro: 38,
        id_tipo_filtro: "5",
        descricao: "Antecipação s/ enc. fase de trib",
        legenda: "4",
        descricao_importador: "Antecipação s/ enc. fase de trib",
        exibe_cenario: "1",
        value: "38",
        label: "Antecipação s/ enc. fase de trib"
      },
      {
        id_filtro: 36,
        id_tipo_filtro: "5",
        descricao: "DIFAL contribuinte",
        legenda: "2",
        descricao_importador: "DIFAL contribuinte do ICMS",
        exibe_cenario: "1",
        value: "36",
        label: "DIFAL contribuinte"
      },
      {
        id_filtro: 37,
        id_tipo_filtro: "5",
        descricao: "DIFAL não Contribuinte",
        legenda: "3",
        descricao_importador: "DIFAL não Contribuinte do ICMS",
        exibe_cenario: "1",
        value: "37",
        label: "DIFAL não Contribuinte"
      },
      {
        id_filtro: 35,
        id_tipo_filtro: "5",
        descricao: "DIFAL-ST",
        legenda: "1",
        descricao_importador: "DIFAL-ST",
        exibe_cenario: "1",
        value: "35",
        label: "DIFAL-ST"
      },
      {
        id_filtro: 34,
        id_tipo_filtro: "5",
        descricao: "ICMS ST / Antecip c/enc. fase de trib",
        legenda: "0",
        descricao_importador: "ICMS ST / Antecip c/enc. fase de trib",
        exibe_cenario: "1",
        value: "34",
        label: "ICMS ST / Antecip c/enc. fase de trib"
      }
    ]
  },
  local: {
    id_tipo_filtro: "6",
    descricao: "local",
    tipo_campo: "select",
    html_id: "local",
    dependencia_count: "0",
    valores: [
      {
        id_filtro: 46,
        id_tipo_filtro: "6",
        descricao: "Exportação",
        legenda: "7",
        descricao_importador: "Exportação",
        exibe_cenario: "1",
        value: "46",
        label: "Exportação"
      },
      {
        id_filtro: 41,
        id_tipo_filtro: "6",
        descricao: "Importação",
        legenda: "2",
        descricao_importador: "Importação",
        exibe_cenario: "1",
        value: "41",
        label: "Importação"
      },
      {
        id_filtro: 40,
        id_tipo_filtro: "6",
        descricao: "Interestadual",
        legenda: "1",
        descricao_importador: "Interestadual",
        exibe_cenario: "1",
        value: "40",
        label: "Interestadual"
      },
      {
        id_filtro: 39,
        id_tipo_filtro: "6",
        descricao: "Interna",
        legenda: "0",
        descricao_importador: "Interna",
        exibe_cenario: "1",
        value: "39",
        label: "Interna"
      }
    ]
  },
  atividade: {
    id_tipo_filtro: "7",
    descricao: "atividade",
    tipo_campo: "select",
    html_id: "atividade",
    dependencia_count: "0",
    valores: [
      {
        id_filtro: 48,
        id_tipo_filtro: "7",
        descricao: "Atacado",
        legenda: "atac",
        descricao_importador: "Atacado",
        exibe_cenario: "1",
        value: "48",
        label: "Atacado"
      },
      {
        id_filtro: 47,
        id_tipo_filtro: "7",
        descricao: "Industrial",
        legenda: "ind",
        descricao_importador: "Industrial",
        exibe_cenario: "1",
        value: "47",
        label: "Industrial"
      },
      {
        id_filtro: 50,
        id_tipo_filtro: "7",
        descricao: "Prestador de Serviço",
        legenda: null,
        descricao_importador: "Prestador de Serviço",
        exibe_cenario: "1",
        value: "50",
        label: "Prestador de Serviço"
      },
      {
        id_filtro: 51,
        id_tipo_filtro: "7",
        descricao: "Rural",
        legenda: null,
        descricao_importador: "Rural",
        exibe_cenario: "1",
        value: "51",
        label: "Rural"
      },
      {
        id_filtro: 49,
        id_tipo_filtro: "7",
        descricao: "Varejo",
        legenda: "varej",
        descricao_importador: "Varejo",
        exibe_cenario: "1",
        value: "49",
        label: "Varejo"
      }
    ]
  },
  tipo_atividade: {
    id_tipo_filtro: "8",
    descricao: "tipo atividade",
    tipo_campo: "select",
    html_id: "tipo_atividade",
    dependencia_count: "2",
    valores: [
      {
        id_filtro: 55,
        id_tipo_filtro: "8",
        descricao: "Entidade imune/isenta",
        legenda: "isento",
        descricao_importador: "Entidade imune/isenta",
        exibe_cenario: "1",
        value: "55",
        label: "Entidade imune/isenta"
      },
      {
        id_filtro: 54,
        id_tipo_filtro: "8",
        descricao: "Órgãos Públicos da Administração Direta, Fundações Públicas e Autarquias",
        legenda: "publico",
        descricao_importador:
          "Órgãos Públicos da Administração Direta, Fundações Públicas e Autarquias",
        exibe_cenario: "1",
        value: "54",
        label: "Órgãos Públicos da Administração Direta, Fundações Públicas e Autarquias"
      },
      {
        id_filtro: 56,
        id_tipo_filtro: "8",
        descricao: "Produtor Rural Pessoa Física",
        legenda: "prodpf",
        descricao_importador: "Produtor Rural Pessoa Física",
        exibe_cenario: "1",
        value: "56",
        label: "Produtor Rural Pessoa Física"
      },
      {
        id_filtro: 57,
        id_tipo_filtro: "8",
        descricao: "Produtor Rural Pessoa Jurídica",
        legenda: "prodpj",
        descricao_importador: "Produtor Rural Pessoa Jurídica",
        exibe_cenario: "1",
        value: "57",
        label: "Produtor Rural Pessoa Jurídica"
      },
      {
        id_filtro: 52,
        id_tipo_filtro: "8",
        descricao: "Sujeito ao ICMS",
        legenda: "servicms",
        descricao_importador: "Sujeito ao ICMS",
        exibe_cenario: "1",
        value: "52",
        label: "Sujeito ao ICMS"
      },
      {
        id_filtro: 53,
        id_tipo_filtro: "8",
        descricao: "Sujeito ao ISS",
        legenda: "serv",
        descricao_importador: "Sujeito ao ISS",
        exibe_cenario: "1",
        value: "53",
        label: "Sujeito ao ISS"
      }
    ]
  },
  origem_mercadoria: {
    id_tipo_filtro: "9",
    descricao: "origem da mercadoria",
    tipo_campo: "select",
    html_id: "origem_mercadoria",
    dependencia_count: "0",
    valores: [
      {
        id_filtro: 58,
        id_tipo_filtro: "9",
        descricao: "Importado",
        legenda: "importado",
        descricao_importador: "Importado",
        exibe_cenario: "1",
        value: "58",
        label: "Importado"
      },
      {
        id_filtro: 59,
        id_tipo_filtro: "9",
        descricao: "Nacional",
        legenda: "nacional",
        descricao_importador: "Nacional",
        exibe_cenario: "1",
        value: "59",
        label: "Nacional"
      },
      {
        id_filtro: 60,
        id_tipo_filtro: "9",
        descricao: "Nacional (PPB)",
        legenda: "nacionalppb",
        descricao_importador: "Nacional (PPB)",
        exibe_cenario: "1",
        value: "60",
        label: "Nacional (PPB)"
      },
      {
        id_filtro: 61,
        id_tipo_filtro: "9",
        descricao: "Nacional com Conteúdo de Importação superior a 40%",
        legenda: "nacional40",
        descricao_importador: "Nacional com Conteúdo de Importação superior a 40%",
        exibe_cenario: "1",
        value: "61",
        label: "Nacional com Conteúdo de Importação superior a 40%"
      }
    ]
  },
  estado_origem: {
    id_tipo_filtro: "10",
    descricao: "estado origem",
    tipo_campo: "select",
    html_id: "estado_origem",
    dependencia_count: "3",
    valores: [
      {
        id_estado: 1,
        sigla: "AC",
        estado: "Acre",
        created_at: "2019-01-04 00:00:00",
        updated_at: "2019-01-04 00:00:00",
        label: "Acre",
        value: "1"
      },
      {
        id_estado: 2,
        sigla: "AL",
        estado: "Alagoas",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Alagoas",
        value: "2"
      },
      {
        id_estado: 4,
        sigla: "AP",
        estado: "Amapá",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Amapá",
        value: "4"
      },
      {
        id_estado: 3,
        sigla: "AM",
        estado: "Amazonas",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Amazonas",
        value: "3"
      },
      {
        id_estado: 5,
        sigla: "BA",
        estado: "Bahia",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Bahia",
        value: "5"
      },
      {
        id_estado: 6,
        sigla: "CE",
        estado: "Ceará",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Ceará",
        value: "6"
      },
      {
        id_estado: 7,
        sigla: "DF",
        estado: "Distrito Federal",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Distrito Federal",
        value: "7"
      },
      {
        id_estado: 8,
        sigla: "ES",
        estado: "Espírito Santo",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Espírito Santo",
        value: "8"
      },
      {
        id_estado: 9,
        sigla: "GO",
        estado: "Goiás",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Goiás",
        value: "9"
      },
      {
        id_estado: 10,
        sigla: "MA",
        estado: "Maranhão",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Maranhão",
        value: "10"
      },
      {
        id_estado: 13,
        sigla: "MT",
        estado: "Mato Grosso",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Mato Grosso",
        value: "13"
      },
      {
        id_estado: 12,
        sigla: "MS",
        estado: "Mato Grosso do Sul",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Mato Grosso do Sul",
        value: "12"
      },
      {
        id_estado: 11,
        sigla: "MG",
        estado: "Minas Gerais",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Minas Gerais",
        value: "11"
      },
      {
        id_estado: 14,
        sigla: "PA",
        estado: "Pará",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Pará",
        value: "14"
      },
      {
        id_estado: 15,
        sigla: "PB",
        estado: "Paraíba",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Paraíba",
        value: "15"
      },
      {
        id_estado: 18,
        sigla: "PR",
        estado: "Paraná",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Paraná",
        value: "18"
      },
      {
        id_estado: 16,
        sigla: "PE",
        estado: "Pernambuco",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Pernambuco",
        value: "16"
      },
      {
        id_estado: 17,
        sigla: "PI",
        estado: "Piauí",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Piauí",
        value: "17"
      },
      {
        id_estado: 19,
        sigla: "RJ",
        estado: "Rio de Janeiro",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Rio de Janeiro",
        value: "19"
      },
      {
        id_estado: 20,
        sigla: "RN",
        estado: "Rio Grande do Norte",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Rio Grande do Norte",
        value: "20"
      },
      {
        id_estado: 23,
        sigla: "RS",
        estado: "Rio Grande do Sul",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Rio Grande do Sul",
        value: "23"
      },
      {
        id_estado: 21,
        sigla: "RO",
        estado: "Rondônia",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Rondônia",
        value: "21"
      },
      {
        id_estado: 22,
        sigla: "RR",
        estado: "Roraima",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Roraima",
        value: "22"
      },
      {
        id_estado: 24,
        sigla: "SC",
        estado: "Santa Catarina",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Santa Catarina",
        value: "24"
      },
      {
        id_estado: 26,
        sigla: "SP",
        estado: "São Paulo",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "São Paulo",
        value: "26"
      },
      {
        id_estado: 25,
        sigla: "SE",
        estado: "Sergipe",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Sergipe",
        value: "25"
      },
      {
        id_estado: 27,
        sigla: "TO",
        estado: "Tocantins",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Tocantins",
        value: "27"
      }
    ]
  },
  estado_destino: {
    id_tipo_filtro: "11",
    descricao: "estado destino",
    tipo_campo: "select",
    html_id: "estado_destino",
    dependencia_count: "2",
    valores: [
      {
        id_estado: 1,
        sigla: "AC",
        estado: "Acre",
        created_at: "2019-01-04 00:00:00",
        updated_at: "2019-01-04 00:00:00",
        label: "Acre",
        value: "1"
      },
      {
        id_estado: 2,
        sigla: "AL",
        estado: "Alagoas",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Alagoas",
        value: "2"
      },
      {
        id_estado: 4,
        sigla: "AP",
        estado: "Amapá",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Amapá",
        value: "4"
      },
      {
        id_estado: 3,
        sigla: "AM",
        estado: "Amazonas",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Amazonas",
        value: "3"
      },
      {
        id_estado: 5,
        sigla: "BA",
        estado: "Bahia",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Bahia",
        value: "5"
      },
      {
        id_estado: 6,
        sigla: "CE",
        estado: "Ceará",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Ceará",
        value: "6"
      },
      {
        id_estado: 7,
        sigla: "DF",
        estado: "Distrito Federal",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Distrito Federal",
        value: "7"
      },
      {
        id_estado: 8,
        sigla: "ES",
        estado: "Espírito Santo",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Espírito Santo",
        value: "8"
      },
      {
        id_estado: 9,
        sigla: "GO",
        estado: "Goiás",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Goiás",
        value: "9"
      },
      {
        id_estado: 10,
        sigla: "MA",
        estado: "Maranhão",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Maranhão",
        value: "10"
      },
      {
        id_estado: 13,
        sigla: "MT",
        estado: "Mato Grosso",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Mato Grosso",
        value: "13"
      },
      {
        id_estado: 12,
        sigla: "MS",
        estado: "Mato Grosso do Sul",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Mato Grosso do Sul",
        value: "12"
      },
      {
        id_estado: 11,
        sigla: "MG",
        estado: "Minas Gerais",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Minas Gerais",
        value: "11"
      },
      {
        id_estado: 14,
        sigla: "PA",
        estado: "Pará",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Pará",
        value: "14"
      },
      {
        id_estado: 15,
        sigla: "PB",
        estado: "Paraíba",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Paraíba",
        value: "15"
      },
      {
        id_estado: 18,
        sigla: "PR",
        estado: "Paraná",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Paraná",
        value: "18"
      },
      {
        id_estado: 16,
        sigla: "PE",
        estado: "Pernambuco",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Pernambuco",
        value: "16"
      },
      {
        id_estado: 17,
        sigla: "PI",
        estado: "Piauí",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Piauí",
        value: "17"
      },
      {
        id_estado: 19,
        sigla: "RJ",
        estado: "Rio de Janeiro",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Rio de Janeiro",
        value: "19"
      },
      {
        id_estado: 20,
        sigla: "RN",
        estado: "Rio Grande do Norte",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Rio Grande do Norte",
        value: "20"
      },
      {
        id_estado: 23,
        sigla: "RS",
        estado: "Rio Grande do Sul",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Rio Grande do Sul",
        value: "23"
      },
      {
        id_estado: 21,
        sigla: "RO",
        estado: "Rondônia",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Rondônia",
        value: "21"
      },
      {
        id_estado: 22,
        sigla: "RR",
        estado: "Roraima",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Roraima",
        value: "22"
      },
      {
        id_estado: 24,
        sigla: "SC",
        estado: "Santa Catarina",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Santa Catarina",
        value: "24"
      },
      {
        id_estado: 26,
        sigla: "SP",
        estado: "São Paulo",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "São Paulo",
        value: "26"
      },
      {
        id_estado: 25,
        sigla: "SE",
        estado: "Sergipe",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Sergipe",
        value: "25"
      },
      {
        id_estado: 27,
        sigla: "TO",
        estado: "Tocantins",
        created_at: "2019-01-09 11:23:18",
        updated_at: "2019-01-09 11:23:18",
        label: "Tocantins",
        value: "27"
      }
    ]
  },
  pais_origem: {
    id_tipo_filtro: "12",
    descricao: "pais origem",
    tipo_campo: "select",
    html_id: "pais_origem",
    dependencia_count: "1",
    valores: [
      {
        id_pais: 327,
        pais: "A Designar",
        sigla: "AD",
        codigo_ibge: null,
        codigo_bacen: "994",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "A Designar",
        value: "327"
      },
      {
        id_pais: 1,
        pais: "Afeganistao",
        sigla: "AF",
        codigo_ibge: "4",
        codigo_bacen: "13",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Afeganistão",
        value: "1"
      },
      {
        id_pais: 2,
        pais: "Africa do Sul",
        sigla: "ZA",
        codigo_ibge: "710",
        codigo_bacen: "756",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "África do Sul",
        value: "2"
      },
      {
        id_pais: 328,
        pais: "Aland, Ilhas",
        sigla: "AI",
        codigo_ibge: "248",
        codigo_bacen: "15",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Aland, Ilhas",
        value: "328"
      },
      {
        id_pais: 3,
        pais: "Albania",
        sigla: "AL",
        codigo_ibge: "8",
        codigo_bacen: "17",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Albânia",
        value: "3"
      },
      {
        id_pais: 4,
        pais: "Alemanha",
        sigla: "DE",
        codigo_ibge: "276",
        codigo_bacen: "23",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Alemanha",
        value: "4"
      },
      {
        id_pais: 5,
        pais: "Andorra",
        sigla: "AD",
        codigo_ibge: "20",
        codigo_bacen: "37",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Andorra",
        value: "5"
      },
      {
        id_pais: 6,
        pais: "Angola",
        sigla: "AO",
        codigo_ibge: "24",
        codigo_bacen: "40",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Angola",
        value: "6"
      },
      {
        id_pais: 254,
        pais: "Anguilla",
        sigla: "AI",
        codigo_ibge: "660",
        codigo_bacen: "41",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Anguilla",
        value: "254"
      },
      {
        id_pais: 329,
        pais: "Antártica",
        sigla: "AQ",
        codigo_ibge: null,
        codigo_bacen: "42",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Antártica",
        value: "329"
      },
      {
        id_pais: 9,
        pais: "Antígua e Barbuda",
        sigla: "AG",
        codigo_ibge: "28",
        codigo_bacen: "43",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Antígua e Barbuda",
        value: "9"
      },
      {
        id_pais: 255,
        pais: "Antilhas Holandesas ",
        sigla: "AN",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Antilhas Holandesas ",
        value: "255"
      },
      {
        id_pais: 11,
        pais: "Arábia Saudita",
        sigla: "SA",
        codigo_ibge: "682",
        codigo_bacen: "53",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Arábia Saudita",
        value: "11"
      },
      {
        id_pais: 12,
        pais: "Argelia",
        sigla: "DZ",
        codigo_ibge: "12",
        codigo_bacen: "59",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Argélia",
        value: "12"
      },
      {
        id_pais: 13,
        pais: "Argentina",
        sigla: "AR",
        codigo_ibge: "32",
        codigo_bacen: "63",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Argentina",
        value: "13"
      },
      {
        id_pais: 14,
        pais: "Armenia, República da",
        sigla: "AM",
        codigo_ibge: "51",
        codigo_bacen: "64",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Armênia, República da",
        value: "14"
      },
      {
        id_pais: 256,
        pais: "Aruba",
        sigla: "AW",
        codigo_ibge: "533",
        codigo_bacen: "65",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Aruba",
        value: "256"
      },
      {
        id_pais: 16,
        pais: "Australia",
        sigla: "AU",
        codigo_ibge: "36",
        codigo_bacen: "69",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Austrália",
        value: "16"
      },
      {
        id_pais: 17,
        pais: "Austria",
        sigla: "AT",
        codigo_ibge: "40",
        codigo_bacen: "72",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Áustria",
        value: "17"
      },
      {
        id_pais: 18,
        pais: "Azerbaijao, República do",
        sigla: "AZ",
        codigo_ibge: "31",
        codigo_bacen: "73",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Azerbaijão, República do",
        value: "18"
      },
      {
        id_pais: 19,
        pais: "Bahamas, Ilhas",
        sigla: "BS",
        codigo_ibge: "44",
        codigo_bacen: "77",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bahamas, Ilhas",
        value: "19"
      },
      {
        id_pais: 20,
        pais: "Bahrein, Ilhas",
        sigla: "BH",
        codigo_ibge: "48",
        codigo_bacen: "80",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bahrein, Ilhas",
        value: "20"
      },
      {
        id_pais: 330,
        pais: "Bancos Centrais",
        sigla: "BC",
        codigo_ibge: null,
        codigo_bacen: "995",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bancos Centrais",
        value: "330"
      },
      {
        id_pais: 21,
        pais: "Bangladesh",
        sigla: "BD",
        codigo_ibge: "50",
        codigo_bacen: "81",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bangladesh",
        value: "21"
      },
      {
        id_pais: 22,
        pais: "Barbados",
        sigla: "BB",
        codigo_ibge: "52",
        codigo_bacen: "83",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Barbados",
        value: "22"
      },
      {
        id_pais: 23,
        pais: "Belarus, República da",
        sigla: "BY",
        codigo_ibge: null,
        codigo_bacen: "85",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Belarus, República da",
        value: "23"
      },
      {
        id_pais: 24,
        pais: "Belgica",
        sigla: "BE",
        codigo_ibge: "56",
        codigo_bacen: "87",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bélgica",
        value: "24"
      },
      {
        id_pais: 25,
        pais: "Belize",
        sigla: "BZ",
        codigo_ibge: "84",
        codigo_bacen: "88",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Belize",
        value: "25"
      },
      {
        id_pais: 26,
        pais: "Benin",
        sigla: "BJ",
        codigo_ibge: "204",
        codigo_bacen: "229",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Benin",
        value: "26"
      },
      {
        id_pais: 27,
        pais: "Bermudas",
        sigla: "BM",
        codigo_ibge: "60",
        codigo_bacen: "90",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bermudas",
        value: "27"
      },
      {
        id_pais: 331,
        pais: "Bielorussia",
        sigla: "BO",
        codigo_ibge: "112",
        codigo_bacen: null,
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bielorússia",
        value: "331"
      },
      {
        id_pais: 28,
        pais: "Bolivia, Estado Plurinacional da",
        sigla: "BO",
        codigo_ibge: "68",
        codigo_bacen: "97",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bolívia, Estado Plurinacional da",
        value: "28"
      },
      {
        id_pais: 332,
        pais: "Bonaire, Saint Eustatius e Saba",
        sigla: "BQ",
        codigo_ibge: "535",
        codigo_bacen: "99",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bonaire, Saint Eustatius e Saba",
        value: "332"
      },
      {
        id_pais: 29,
        pais: "Bosnia-Herzegovina (República da)",
        sigla: "BA",
        codigo_ibge: "70",
        codigo_bacen: "98",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bósnia-Herzegovina (República da)",
        value: "29"
      },
      {
        id_pais: 30,
        pais: "Botsuana",
        sigla: "BW",
        codigo_ibge: "72",
        codigo_bacen: "101",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Botsuana",
        value: "30"
      },
      {
        id_pais: 333,
        pais: "Bouvet, Ilha",
        sigla: "BV",
        codigo_ibge: null,
        codigo_bacen: "102",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bouvet, Ilha",
        value: "333"
      },
      {
        id_pais: 32,
        pais: "Brunei",
        sigla: "BN",
        codigo_ibge: "96",
        codigo_bacen: "108",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Brunei",
        value: "32"
      },
      {
        id_pais: 33,
        pais: "Bulgaria, República da",
        sigla: "BG",
        codigo_ibge: "400",
        codigo_bacen: "111",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bulgária, República da",
        value: "33"
      },
      {
        id_pais: 34,
        pais: "Burkina Faso",
        sigla: "BF",
        codigo_ibge: "854",
        codigo_bacen: "31",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Burkina Faso",
        value: "34"
      },
      {
        id_pais: 35,
        pais: "Burundi",
        sigla: "BI",
        codigo_ibge: "108",
        codigo_bacen: "115",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Burundi",
        value: "35"
      },
      {
        id_pais: 36,
        pais: "Butao",
        sigla: "BT",
        codigo_ibge: "64",
        codigo_bacen: "119",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Butão",
        value: "36"
      },
      {
        id_pais: 37,
        pais: "Cabo Verde, República de",
        sigla: "CV",
        codigo_ibge: "132",
        codigo_bacen: "127",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cabo Verde, República de",
        value: "37"
      },
      {
        id_pais: 38,
        pais: "Camaroes",
        sigla: "CM",
        codigo_ibge: "120",
        codigo_bacen: "145",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Camarões",
        value: "38"
      },
      {
        id_pais: 39,
        pais: "Camboja",
        sigla: "KH",
        codigo_ibge: "116",
        codigo_bacen: "141",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Camboja",
        value: "39"
      },
      {
        id_pais: 40,
        pais: "Canada",
        sigla: "CA",
        codigo_ibge: "124",
        codigo_bacen: "149",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Canadá",
        value: "40"
      },
      {
        id_pais: 266,
        pais: "Canárias, Ilhas",
        sigla: "CS",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Canárias, Ilhas",
        value: "266"
      },
      {
        id_pais: 144,
        pais: "Catar",
        sigla: "QA",
        codigo_ibge: "634",
        codigo_bacen: "154",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Catar",
        value: "144"
      },
      {
        id_pais: 57,
        pais: "Cayman, Ilhas",
        sigla: "KY",
        codigo_ibge: "136",
        codigo_bacen: "137",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cayman, Ilhas",
        value: "57"
      },
      {
        id_pais: 41,
        pais: "Cazaquistao, República do",
        sigla: "KZ",
        codigo_ibge: "398",
        codigo_bacen: "153",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cazaquistão, República do",
        value: "41"
      },
      {
        id_pais: 42,
        pais: "Chade",
        sigla: "TD",
        codigo_ibge: "148",
        codigo_bacen: "788",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Chade",
        value: "42"
      },
      {
        id_pais: 43,
        pais: "Chile",
        sigla: "CL",
        codigo_ibge: "152",
        codigo_bacen: "158",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Chile",
        value: "43"
      },
      {
        id_pais: 44,
        pais: "China",
        sigla: "CN",
        codigo_ibge: "156",
        codigo_bacen: "160",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "China",
        value: "44"
      },
      {
        id_pais: 45,
        pais: "Chipre",
        sigla: "CY",
        codigo_ibge: "196",
        codigo_bacen: "163",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Chipre",
        value: "45"
      },
      {
        id_pais: 263,
        pais: "Christmas, Ilha (Navidad)",
        sigla: "CX",
        codigo_ibge: null,
        codigo_bacen: "511",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Christmas, Ilha (Navidad)",
        value: "263"
      },
      {
        id_pais: 46,
        pais: "Cingapura",
        sigla: "SG",
        codigo_ibge: "702",
        codigo_bacen: "741",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cingapura",
        value: "46"
      },
      {
        id_pais: 267,
        pais: "Cocos (Keeling), Ilhas",
        sigla: "CC",
        codigo_ibge: null,
        codigo_bacen: "165",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cocos (Keeling), Ilhas",
        value: "267"
      },
      {
        id_pais: 47,
        pais: "Colombia",
        sigla: "CO",
        codigo_ibge: "170",
        codigo_bacen: "169",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Colômbia",
        value: "47"
      },
      {
        id_pais: 257,
        pais: "Comores, Ilhas",
        sigla: "KM",
        codigo_ibge: "174",
        codigo_bacen: "173",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Comores, Ilhas",
        value: "257"
      },
      {
        id_pais: 48,
        pais: "Congo",
        sigla: "CG",
        codigo_ibge: "178",
        codigo_bacen: "177",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Congo",
        value: "48"
      },
      {
        id_pais: 147,
        pais: "Congo, República Democratica do",
        sigla: "CD",
        codigo_ibge: "180",
        codigo_bacen: "888",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Congo, República Democratica do",
        value: "147"
      },
      {
        id_pais: 268,
        pais: "Cook, Ilhas",
        sigla: "CK",
        codigo_ibge: "184",
        codigo_bacen: "183",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cook, Ilhas",
        value: "268"
      },
      {
        id_pais: 49,
        pais: "Coreia (do Norte), Rep. Pop. Democratica",
        sigla: "KP",
        codigo_ibge: "408",
        codigo_bacen: "187",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Coréia (do Norte), Rep. Pop. Democrática",
        value: "49"
      },
      {
        id_pais: 50,
        pais: "Coreia (do Sul), República da",
        sigla: "KR",
        codigo_ibge: "410",
        codigo_bacen: "190",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Coréia (do Sul), República da",
        value: "50"
      },
      {
        id_pais: 51,
        pais: "Costa do Marfim",
        sigla: "CI",
        codigo_ibge: "384",
        codigo_bacen: "193",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Costa do Marfim",
        value: "51"
      },
      {
        id_pais: 201,
        pais: "Costa Rica",
        sigla: "CR",
        codigo_ibge: "188",
        codigo_bacen: "196",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Costa Rica",
        value: "201"
      },
      {
        id_pais: 334,
        pais: "Coveite",
        sigla: null,
        codigo_ibge: null,
        codigo_bacen: "198",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Coveite",
        value: "334"
      },
      {
        id_pais: 224,
        pais: "Croacia (República da)",
        sigla: "HR",
        codigo_ibge: "191",
        codigo_bacen: "195",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Croácia (República da)",
        value: "224"
      },
      {
        id_pais: 202,
        pais: "Cuba",
        sigla: "CU",
        codigo_ibge: "192",
        codigo_bacen: "199",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cuba",
        value: "202"
      },
      {
        id_pais: 335,
        pais: "Curacao",
        sigla: "CW",
        codigo_ibge: "531",
        codigo_bacen: "200",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Curaçao",
        value: "335"
      },
      {
        id_pais: 225,
        pais: "Dinamarca",
        sigla: "DK",
        codigo_ibge: "208",
        codigo_bacen: "232",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Dinamarca",
        value: "225"
      },
      {
        id_pais: 226,
        pais: "Djibuti",
        sigla: "DJ",
        codigo_ibge: "262",
        codigo_bacen: "783",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Djibuti",
        value: "226"
      },
      {
        id_pais: 203,
        pais: "Dominica, Ilha",
        sigla: "DM",
        codigo_ibge: "212",
        codigo_bacen: "235",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Dominica, Ilha",
        value: "203"
      },
      {
        id_pais: 227,
        pais: "Egito",
        sigla: "EG",
        codigo_ibge: "818",
        codigo_bacen: "240",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Egito",
        value: "227"
      },
      {
        id_pais: 211,
        pais: "El Salvador",
        sigla: "SV",
        codigo_ibge: "222",
        codigo_bacen: "687",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "El Salvador",
        value: "211"
      },
      {
        id_pais: 213,
        pais: "Emirados Arabes Unidos",
        sigla: "AE",
        codigo_ibge: "784",
        codigo_bacen: "244",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Emirados Árabes Unidos",
        value: "213"
      },
      {
        id_pais: 204,
        pais: "Equador",
        sigla: "EC",
        codigo_ibge: "218",
        codigo_bacen: "239",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Equador",
        value: "204"
      },
      {
        id_pais: 228,
        pais: "Eritreia",
        sigla: "ER",
        codigo_ibge: "232",
        codigo_bacen: "243",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Eritreia",
        value: "228"
      },
      {
        id_pais: 258,
        pais: "Escócia",
        sigla: "TS",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Escócia",
        value: "258"
      },
      {
        id_pais: 230,
        pais: "Eslovaca, República",
        sigla: "SK",
        codigo_ibge: "703",
        codigo_bacen: "247",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Eslovaca, República",
        value: "230"
      },
      {
        id_pais: 231,
        pais: "Eslovenia, República da",
        sigla: "SI",
        codigo_ibge: "705",
        codigo_bacen: "246",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Eslovênia, República da",
        value: "231"
      },
      {
        id_pais: 232,
        pais: "Espanha",
        sigla: "ES",
        codigo_ibge: "724",
        codigo_bacen: "245",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Espanha",
        value: "232"
      },
      {
        id_pais: 233,
        pais: "Estados Unidos",
        sigla: "US",
        codigo_ibge: "840",
        codigo_bacen: "249",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Estados Unidos",
        value: "233"
      },
      {
        id_pais: 234,
        pais: "Estonia, República da",
        sigla: "EE",
        codigo_ibge: "233",
        codigo_bacen: "251",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Estônia, República da",
        value: "234"
      },
      {
        id_pais: 336,
        pais: "Eswatini",
        sigla: null,
        codigo_ibge: null,
        codigo_bacen: "754",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Eswatini",
        value: "336"
      },
      {
        id_pais: 235,
        pais: "Etiopia",
        sigla: "ET",
        codigo_ibge: "231",
        codigo_bacen: "253",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Etiópia",
        value: "235"
      },
      {
        id_pais: 271,
        pais: "Falkland (Ilhas Malvinas)",
        sigla: "FK",
        codigo_ibge: "238",
        codigo_bacen: "255",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Falkland (Ilhas Malvinas)",
        value: "271"
      },
      {
        id_pais: 269,
        pais: "Feroe, Ilhas",
        sigla: "FO",
        codigo_ibge: "234",
        codigo_bacen: "259",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Feroe, Ilhas",
        value: "269"
      },
      {
        id_pais: 237,
        pais: "Fiji",
        sigla: "FJ",
        codigo_ibge: "242",
        codigo_bacen: "870",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Fiji",
        value: "237"
      },
      {
        id_pais: 238,
        pais: "Filipinas",
        sigla: "PH",
        codigo_ibge: "608",
        codigo_bacen: "267",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Filipinas",
        value: "238"
      },
      {
        id_pais: 239,
        pais: "Finlandia",
        sigla: "FI",
        codigo_ibge: "246",
        codigo_bacen: "271",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Finlândia",
        value: "239"
      },
      {
        id_pais: 177,
        pais: "Formosa (Taiwan)",
        sigla: "TW",
        codigo_ibge: null,
        codigo_bacen: "161",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Formosa (Taiwan)",
        value: "177"
      },
      {
        id_pais: 240,
        pais: "Franca",
        sigla: "FR",
        codigo_ibge: "250",
        codigo_bacen: "275",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Franca",
        value: "240"
      },
      {
        id_pais: 241,
        pais: "Gabao",
        sigla: "GA",
        codigo_ibge: "266",
        codigo_bacen: "281",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Gabão",
        value: "241"
      },
      {
        id_pais: 206,
        pais: "Gambia",
        sigla: "GM",
        codigo_ibge: "270",
        codigo_bacen: "285",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Gâmbia",
        value: "206"
      },
      {
        id_pais: 243,
        pais: "Gana",
        sigla: "GH",
        codigo_ibge: "288",
        codigo_bacen: "289",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Gana",
        value: "243"
      },
      {
        id_pais: 337,
        pais: "Geórgia do Sul e Sandwich do Sul, Ilhas",
        sigla: "GS",
        codigo_ibge: null,
        codigo_bacen: "292",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Geórgia do Sul e Sandwich do Sul, Ilhas",
        value: "337"
      },
      {
        id_pais: 242,
        pais: "Georgia, República da",
        sigla: "GE",
        codigo_ibge: "268",
        codigo_bacen: "291",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Geórgia, República da",
        value: "242"
      },
      {
        id_pais: 259,
        pais: "Gibraltar",
        sigla: "GI",
        codigo_ibge: "292",
        codigo_bacen: "293",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Gibraltar",
        value: "259"
      },
      {
        id_pais: 205,
        pais: "Granada",
        sigla: "GD",
        codigo_ibge: "308",
        codigo_bacen: "297",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Granada",
        value: "205"
      },
      {
        id_pais: 245,
        pais: "Grecia",
        sigla: "GR",
        codigo_ibge: "300",
        codigo_bacen: "301",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Grécia",
        value: "245"
      },
      {
        id_pais: 338,
        pais: "Groenlandia",
        sigla: "GL",
        codigo_ibge: "304",
        codigo_bacen: "305",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Groenlândia",
        value: "338"
      },
      {
        id_pais: 339,
        pais: "Guadalupe",
        sigla: "GP",
        codigo_ibge: "312",
        codigo_bacen: "309",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guadalupe",
        value: "339"
      },
      {
        id_pais: 340,
        pais: "Guam",
        sigla: "GU",
        codigo_ibge: "316",
        codigo_bacen: "313",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guam",
        value: "340"
      },
      {
        id_pais: 207,
        pais: "Guatemala",
        sigla: "GT",
        codigo_ibge: "320",
        codigo_bacen: "317",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guatemala",
        value: "207"
      },
      {
        id_pais: 341,
        pais: "Guernsey",
        sigla: "GG",
        codigo_ibge: "831",
        codigo_bacen: "321",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guernsey",
        value: "341"
      },
      {
        id_pais: 208,
        pais: "Guiana",
        sigla: "GY",
        codigo_ibge: "328",
        codigo_bacen: "337",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guiana",
        value: "208"
      },
      {
        id_pais: 212,
        pais: "Guiana Francesa",
        sigla: "GF",
        codigo_ibge: "254",
        codigo_bacen: "325",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guiana Francesa",
        value: "212"
      },
      {
        id_pais: 249,
        pais: "Guine",
        sigla: "GN",
        codigo_ibge: "324",
        codigo_bacen: "329",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guine",
        value: "249"
      },
      {
        id_pais: 215,
        pais: "Guine-Bissau",
        sigla: "GW",
        codigo_ibge: "624",
        codigo_bacen: "334",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guine-Bissau",
        value: "215"
      },
      {
        id_pais: 216,
        pais: "Guine-Equatorial",
        sigla: "GQ",
        codigo_ibge: "226",
        codigo_bacen: "331",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guine-Equatorial",
        value: "216"
      },
      {
        id_pais: 210,
        pais: "Haiti",
        sigla: "HT",
        codigo_ibge: "332",
        codigo_bacen: "341",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Haiti",
        value: "210"
      },
      {
        id_pais: 342,
        pais: "Heard e Ilhas McDonald, Ilha",
        sigla: "HM",
        codigo_ibge: null,
        codigo_bacen: "343",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Heard e Ilhas McDonald, Ilha",
        value: "342"
      },
      {
        id_pais: 209,
        pais: "Honduras",
        sigla: "HN",
        codigo_ibge: "340",
        codigo_bacen: "345",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Honduras",
        value: "209"
      },
      {
        id_pais: 218,
        pais: "Hong Kong",
        sigla: "HK",
        codigo_ibge: "344",
        codigo_bacen: "351",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Hong Kong",
        value: "218"
      },
      {
        id_pais: 219,
        pais: "Hungria, República da",
        sigla: "HU",
        codigo_ibge: "348",
        codigo_bacen: "355",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Hungria, República da",
        value: "219"
      },
      {
        id_pais: 220,
        pais: "Iemen",
        sigla: "YE",
        codigo_ibge: "887",
        codigo_bacen: "357",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Iemen",
        value: "220"
      },
      {
        id_pais: 77,
        pais: "India",
        sigla: "IN",
        codigo_ibge: "356",
        codigo_bacen: "361",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Índia",
        value: "77"
      },
      {
        id_pais: 78,
        pais: "Indonesia",
        sigla: "ID",
        codigo_ibge: "360",
        codigo_bacen: "365",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Indonésia",
        value: "78"
      },
      {
        id_pais: 279,
        pais: "Inglaterra",
        sigla: "GB",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Inglaterra",
        value: "279"
      },
      {
        id_pais: 79,
        pais: "Ira, República Islamica do",
        sigla: "IR",
        codigo_ibge: "364",
        codigo_bacen: "372",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Ira, República Islamica do",
        value: "79"
      },
      {
        id_pais: 80,
        pais: "Iraque",
        sigla: "IQ",
        codigo_ibge: "368",
        codigo_bacen: "369",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Iraque",
        value: "80"
      },
      {
        id_pais: 81,
        pais: "Irlanda",
        sigla: "IE",
        codigo_ibge: "372",
        codigo_bacen: "375",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Irlanda",
        value: "81"
      },
      {
        id_pais: 82,
        pais: "Islandia",
        sigla: "IS",
        codigo_ibge: "352",
        codigo_bacen: "379",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Islândia",
        value: "82"
      },
      {
        id_pais: 83,
        pais: "Israel",
        sigla: "IL",
        codigo_ibge: "376",
        codigo_bacen: "383",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Israel",
        value: "83"
      },
      {
        id_pais: 84,
        pais: "Italia",
        sigla: "IT",
        codigo_ibge: "380",
        codigo_bacen: "386",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Itália",
        value: "84"
      },
      {
        id_pais: 85,
        pais: "Jamaica",
        sigla: "JM",
        codigo_ibge: "388",
        codigo_bacen: "391",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Jamaica",
        value: "85"
      },
      {
        id_pais: 86,
        pais: "Japao",
        sigla: "JP",
        codigo_ibge: "392",
        codigo_bacen: "399",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Japão",
        value: "86"
      },
      {
        id_pais: 343,
        pais: "Jersey",
        sigla: "JE",
        codigo_ibge: "832",
        codigo_bacen: "393",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Jersey",
        value: "343"
      },
      {
        id_pais: 270,
        pais: "Johnston, Ilhas",
        sigla: "IJ",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Johnston, Ilhas",
        value: "270"
      },
      {
        id_pais: 88,
        pais: "Jordania",
        sigla: "JO",
        codigo_ibge: "400",
        codigo_bacen: "403",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Jordânia",
        value: "88"
      },
      {
        id_pais: 90,
        pais: "Kiribati",
        sigla: "KI",
        codigo_ibge: "296",
        codigo_bacen: "411",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Kiribati",
        value: "90"
      },
      {
        id_pais: 91,
        pais: "Kuwait",
        sigla: "KW",
        codigo_ibge: "414",
        codigo_bacen: null,
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Kuwait",
        value: "91"
      },
      {
        id_pais: 280,
        pais: "Labuão (Lebuan)",
        sigla: "LN",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Labuão (Lebuan)",
        value: "280"
      },
      {
        id_pais: 92,
        pais: "Laos, Rep. Pop. Democr. do",
        sigla: "LA",
        codigo_ibge: "418",
        codigo_bacen: "420",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Laos, Rep. Pop. Democr. do",
        value: "92"
      },
      {
        id_pais: 94,
        pais: "Lesoto",
        sigla: "LS",
        codigo_ibge: "426",
        codigo_bacen: "426",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Lesoto",
        value: "94"
      },
      {
        id_pais: 281,
        pais: "Letônia (Latvia)",
        sigla: "LV",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Letônia (Latvia)",
        value: "281"
      },
      {
        id_pais: 93,
        pais: "Letonia, República da",
        sigla: "LV",
        codigo_ibge: "428",
        codigo_bacen: "427",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Letônia, República da",
        value: "93"
      },
      {
        id_pais: 95,
        pais: "Libano",
        sigla: "LB",
        codigo_ibge: "422",
        codigo_bacen: "431",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Líbano",
        value: "95"
      },
      {
        id_pais: 96,
        pais: "Liberia",
        sigla: "LR",
        codigo_ibge: "430",
        codigo_bacen: "434",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Liberia",
        value: "96"
      },
      {
        id_pais: 97,
        pais: "Libia",
        sigla: "LY",
        codigo_ibge: "434",
        codigo_bacen: "438",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Líbia",
        value: "97"
      },
      {
        id_pais: 98,
        pais: "Liechtenstein",
        sigla: "LI",
        codigo_ibge: "438",
        codigo_bacen: "440",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Liechtenstein",
        value: "98"
      },
      {
        id_pais: 99,
        pais: "Lituania, República da",
        sigla: "LT",
        codigo_ibge: "440",
        codigo_bacen: "442",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Lituânia, República da",
        value: "99"
      },
      {
        id_pais: 100,
        pais: "Luxemburgo",
        sigla: "LU",
        codigo_ibge: "442",
        codigo_bacen: "445",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Luxemburgo",
        value: "100"
      },
      {
        id_pais: 101,
        pais: "Macau",
        sigla: "MO",
        codigo_ibge: "446",
        codigo_bacen: "447",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Macau",
        value: "101"
      },
      {
        id_pais: 102,
        pais: "Macedonia, Ant. Rep. Iugoslava",
        sigla: "MK",
        codigo_ibge: "807",
        codigo_bacen: "449",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Macedônia, Ant. Rep. Iugoslava",
        value: "102"
      },
      {
        id_pais: 103,
        pais: "Madagascar",
        sigla: "MG",
        codigo_ibge: "450",
        codigo_bacen: "450",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Madagascar",
        value: "103"
      },
      {
        id_pais: 260,
        pais: "Madeira, Ilha da",
        sigla: "WI",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Madeira, Ilha da",
        value: "260"
      },
      {
        id_pais: 104,
        pais: "Malasia",
        sigla: "MY",
        codigo_ibge: "458",
        codigo_bacen: "455",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Malásia",
        value: "104"
      },
      {
        id_pais: 105,
        pais: "Malavi",
        sigla: "MW",
        codigo_ibge: "454",
        codigo_bacen: "458",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Malavi",
        value: "105"
      },
      {
        id_pais: 106,
        pais: "Maldivas",
        sigla: "MV",
        codigo_ibge: "462",
        codigo_bacen: "461",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Maldivas",
        value: "106"
      },
      {
        id_pais: 107,
        pais: "Mali",
        sigla: "ML",
        codigo_ibge: "466",
        codigo_bacen: "464",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mali",
        value: "107"
      },
      {
        id_pais: 108,
        pais: "Malta",
        sigla: "MT",
        codigo_ibge: "470",
        codigo_bacen: "467",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Malta",
        value: "108"
      },
      {
        id_pais: 262,
        pais: "Man, Ilha de",
        sigla: "IM",
        codigo_ibge: "833",
        codigo_bacen: "359",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Man, Ilha de",
        value: "262"
      },
      {
        id_pais: 272,
        pais: "Marianas do Norte",
        sigla: "MP",
        codigo_ibge: "580",
        codigo_bacen: "472",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Marianas do Norte",
        value: "272"
      },
      {
        id_pais: 109,
        pais: "Marrocos",
        sigla: "MA",
        codigo_ibge: "504",
        codigo_bacen: "474",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Marrocos",
        value: "109"
      },
      {
        id_pais: 273,
        pais: "Marshall, Ilhas",
        sigla: "MH",
        codigo_ibge: "584",
        codigo_bacen: "476",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Marshall, Ilhas",
        value: "273"
      },
      {
        id_pais: 282,
        pais: "Martinica",
        sigla: "MQ",
        codigo_ibge: "474",
        codigo_bacen: "477",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Martinica",
        value: "282"
      },
      {
        id_pais: 111,
        pais: "Mauricio",
        sigla: "MU",
        codigo_ibge: "480",
        codigo_bacen: "485",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Maurício",
        value: "111"
      },
      {
        id_pais: 112,
        pais: "Mauritania",
        sigla: "MR",
        codigo_ibge: "478",
        codigo_bacen: "488",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mauritânia",
        value: "112"
      },
      {
        id_pais: 344,
        pais: "Mayotte",
        sigla: "YT",
        codigo_ibge: "175",
        codigo_bacen: "489",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mayotte",
        value: "344"
      },
      {
        id_pais: 114,
        pais: "Mexico",
        sigla: "MX",
        codigo_ibge: "484",
        codigo_bacen: "493",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "México",
        value: "114"
      },
      {
        id_pais: 122,
        pais: "Mianmar (Birmania)",
        sigla: "MM",
        codigo_ibge: "104",
        codigo_bacen: "93",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mianmar (Birmania)",
        value: "122"
      },
      {
        id_pais: 283,
        pais: "Micronesia",
        sigla: "FM",
        codigo_ibge: "583",
        codigo_bacen: "499",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Micronésia",
        value: "283"
      },
      {
        id_pais: 274,
        pais: "Midway, Ilhas",
        sigla: "MI",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Midway, Ilhas",
        value: "274"
      },
      {
        id_pais: 116,
        pais: "Mocambique",
        sigla: "MZ",
        codigo_ibge: "508",
        codigo_bacen: "505",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Moçambique",
        value: "116"
      },
      {
        id_pais: 117,
        pais: "Moldovia, República da",
        sigla: "MD",
        codigo_ibge: "498",
        codigo_bacen: "494",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Moldovia, República da",
        value: "117"
      },
      {
        id_pais: 118,
        pais: "Monaco",
        sigla: "MC",
        codigo_ibge: "492",
        codigo_bacen: "495",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mônaco",
        value: "118"
      },
      {
        id_pais: 119,
        pais: "Mongolia",
        sigla: "MN",
        codigo_ibge: "496",
        codigo_bacen: "497",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mongólia",
        value: "119"
      },
      {
        id_pais: 284,
        pais: "Mont Serrat, Ilhas",
        sigla: "MS",
        codigo_ibge: "500",
        codigo_bacen: "501",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mont Serrat, Ilhas",
        value: "284"
      },
      {
        id_pais: 120,
        pais: "Montenegro",
        sigla: "ME",
        codigo_ibge: "499",
        codigo_bacen: "498",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Montenegro",
        value: "120"
      },
      {
        id_pais: 123,
        pais: "Namibia",
        sigla: "NA",
        codigo_ibge: "516",
        codigo_bacen: "507",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Namíbia",
        value: "123"
      },
      {
        id_pais: 124,
        pais: "Nauru",
        sigla: "NR",
        codigo_ibge: "520",
        codigo_bacen: "508",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Nauru",
        value: "124"
      },
      {
        id_pais: 125,
        pais: "Nepal",
        sigla: "NP",
        codigo_ibge: "524",
        codigo_bacen: "517",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Nepal",
        value: "125"
      },
      {
        id_pais: 126,
        pais: "Nicaragua",
        sigla: "NI",
        codigo_ibge: "558",
        codigo_bacen: "521",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Nicarágua",
        value: "126"
      },
      {
        id_pais: 127,
        pais: "Niger",
        sigla: "NE",
        codigo_ibge: "562",
        codigo_bacen: "525",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Níger",
        value: "127"
      },
      {
        id_pais: 128,
        pais: "Nigeria",
        sigla: "NG",
        codigo_ibge: "566",
        codigo_bacen: "528",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Nigéria",
        value: "128"
      },
      {
        id_pais: 129,
        pais: "Niue, Ilha",
        sigla: "NU",
        codigo_ibge: "570",
        codigo_bacen: "531",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Niue, Ilha",
        value: "129"
      },
      {
        id_pais: 264,
        pais: "Norfolk, Ilha",
        sigla: "NF",
        codigo_ibge: "574",
        codigo_bacen: "535",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Norfolk, Ilha",
        value: "264"
      },
      {
        id_pais: 130,
        pais: "Noruega",
        sigla: "NO",
        codigo_ibge: "578",
        codigo_bacen: "538",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Noruega",
        value: "130"
      },
      {
        id_pais: 285,
        pais: "Nova Caledonia",
        sigla: "NC",
        codigo_ibge: "540",
        codigo_bacen: "542",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Nova Caledônia",
        value: "285"
      },
      {
        id_pais: 132,
        pais: "Nova Zelândia",
        sigla: "NZ",
        codigo_ibge: "554",
        codigo_bacen: "548",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Nova Zelândia",
        value: "132"
      },
      {
        id_pais: 133,
        pais: "Oma",
        sigla: "OM",
        codigo_ibge: "512",
        codigo_bacen: "556",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Omã",
        value: "133"
      },
      {
        id_pais: 345,
        pais: "Organizações Internacionais",
        sigla: null,
        codigo_ibge: null,
        codigo_bacen: "997",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Organizações Internacionais",
        value: "345"
      },
      {
        id_pais: 346,
        pais: "Pacifico, Ilhas do (Possesao dos EUA)",
        sigla: null,
        codigo_ibge: null,
        codigo_bacen: "566",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Pacífico, Ilhas do (Possesão dos EUA)",
        value: "346"
      },
      {
        id_pais: 286,
        pais: "País de Gales",
        sigla: "UK",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "País de Gales",
        value: "286"
      },
      {
        id_pais: 217,
        pais: "Paises Baixos (Holanda)",
        sigla: "NL",
        codigo_ibge: "528",
        codigo_bacen: "573",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Países Baixos (Holanda)",
        value: "217"
      },
      {
        id_pais: 287,
        pais: "Palau",
        sigla: "PW",
        codigo_ibge: "585",
        codigo_bacen: "575",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Palau",
        value: "287"
      },
      {
        id_pais: 347,
        pais: "Palestina",
        sigla: "PS",
        codigo_ibge: "275",
        codigo_bacen: "578",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Palestina",
        value: "347"
      },
      {
        id_pais: 135,
        pais: "Panama",
        sigla: "PA",
        codigo_ibge: "591",
        codigo_bacen: "580",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Panamá",
        value: "135"
      },
      {
        id_pais: 136,
        pais: "Papua Nova Guine",
        sigla: "PG",
        codigo_ibge: "598",
        codigo_bacen: "545",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Papua-Nova Guiné",
        value: "136"
      },
      {
        id_pais: 137,
        pais: "Paquistao",
        sigla: "PK",
        codigo_ibge: "586",
        codigo_bacen: "576",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Paquistão",
        value: "137"
      },
      {
        id_pais: 138,
        pais: "Paraguai",
        sigla: "PY",
        codigo_ibge: "600",
        codigo_bacen: "586",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Paraguai",
        value: "138"
      },
      {
        id_pais: 139,
        pais: "Peru",
        sigla: "PE",
        codigo_ibge: "604",
        codigo_bacen: "589",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Perú",
        value: "139"
      },
      {
        id_pais: 288,
        pais: "Pitcairn, Ilha",
        sigla: "PN",
        codigo_ibge: "612",
        codigo_bacen: "593",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Pitcairn, Ilha",
        value: "288"
      },
      {
        id_pais: 289,
        pais: "Polinesia Francesa",
        sigla: "PF",
        codigo_ibge: "258",
        codigo_bacen: "599",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Polinésia Francesa",
        value: "289"
      },
      {
        id_pais: 141,
        pais: "Polonia, República da",
        sigla: "PL",
        codigo_ibge: "616",
        codigo_bacen: "603",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Polônia, República da",
        value: "141"
      },
      {
        id_pais: 142,
        pais: "Porto Rico",
        sigla: "PR",
        codigo_ibge: "630",
        codigo_bacen: "611",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Porto Rico",
        value: "142"
      },
      {
        id_pais: 143,
        pais: "Portugal",
        sigla: "PT",
        codigo_ibge: "620",
        codigo_bacen: "607",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Portugal",
        value: "143"
      },
      {
        id_pais: 348,
        pais: "Provisao de Navios e Aeronaves",
        sigla: null,
        codigo_ibge: null,
        codigo_bacen: "990",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Provisão de Navios e Aeronaves",
        value: "348"
      },
      {
        id_pais: 290,
        pais: "Quênia",
        sigla: "KE",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Quênia",
        value: "290"
      },
      {
        id_pais: 89,
        pais: "Quenia",
        sigla: "KE",
        codigo_ibge: "404",
        codigo_bacen: "623",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Quenia",
        value: "89"
      },
      {
        id_pais: 145,
        pais: "Quirguiz, República",
        sigla: "KG",
        codigo_ibge: "417",
        codigo_bacen: "625",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Quirguiz, República",
        value: "145"
      },
      {
        id_pais: 223,
        pais: "Reino Unido",
        sigla: "GB",
        codigo_ibge: "826",
        codigo_bacen: "628",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Reino Unido",
        value: "223"
      },
      {
        id_pais: 146,
        pais: "República Centro-Africana",
        sigla: "CF",
        codigo_ibge: "140",
        codigo_bacen: "640",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "República Centro-Africana",
        value: "146"
      },
      {
        id_pais: 148,
        pais: "República Dominicana",
        sigla: "DO",
        codigo_ibge: "214",
        codigo_bacen: "647",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "República Dominicana",
        value: "148"
      },
      {
        id_pais: 261,
        pais: "Reuniao, Ilha",
        sigla: "RE",
        codigo_ibge: "638",
        codigo_bacen: "660",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Reunião, Ilha",
        value: "261"
      },
      {
        id_pais: 150,
        pais: "Romenia",
        sigla: "RO",
        codigo_ibge: "642",
        codigo_bacen: "670",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Romênia",
        value: "150"
      },
      {
        id_pais: 151,
        pais: "Ruanda",
        sigla: "RW",
        codigo_ibge: "646",
        codigo_bacen: "675",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Ruanda",
        value: "151"
      },
      {
        id_pais: 236,
        pais: "Russia, Federacao da",
        sigla: "RU",
        codigo_ibge: "643",
        codigo_bacen: "676",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Rússia, Federação da",
        value: "236"
      },
      {
        id_pais: 152,
        pais: "Saara Ocidental",
        sigla: "EH",
        codigo_ibge: "732",
        codigo_bacen: "685",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Saara Ocidental",
        value: "152"
      },
      {
        id_pais: 70,
        pais: "Salomao, Ilhas ",
        sigla: "SB",
        codigo_ibge: "90",
        codigo_bacen: "677",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Salomão, Ilhas ",
        value: "70"
      },
      {
        id_pais: 155,
        pais: "Samoa",
        sigla: "WS",
        codigo_ibge: "882",
        codigo_bacen: "690",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Samoa",
        value: "155"
      },
      {
        id_pais: 154,
        pais: "Samoa Americana",
        sigla: "AS",
        codigo_ibge: "16",
        codigo_bacen: "691",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Samoa Americana",
        value: "154"
      },
      {
        id_pais: 293,
        pais: "San Marino",
        sigla: "SM",
        codigo_ibge: "674",
        codigo_bacen: "697",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "San Marino",
        value: "293"
      },
      {
        id_pais: 292,
        pais: "Santa Helena",
        sigla: "SH",
        codigo_ibge: "654",
        codigo_bacen: "710",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Santa Helena",
        value: "292"
      },
      {
        id_pais: 158,
        pais: "Santa Lucia",
        sigla: "LC",
        codigo_ibge: "662",
        codigo_bacen: "715",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Santa Lúcia",
        value: "158"
      },
      {
        id_pais: 349,
        pais: "Sao Bartolomeu",
        sigla: "BL",
        codigo_ibge: "652",
        codigo_bacen: "693",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Bartolomeu",
        value: "349"
      },
      {
        id_pais: 160,
        pais: "Sao Cristovao e Neves, Ilhas",
        sigla: "KN",
        codigo_ibge: "659",
        codigo_bacen: "695",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Cristovão e Neves, Ilhas",
        value: "160"
      },
      {
        id_pais: 350,
        pais: "São Martinho, Ilha de (Parte Francesa)",
        sigla: "MA",
        codigo_ibge: "663",
        codigo_bacen: "698",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Martinho, Ilha de (Parte Francesa)",
        value: "350"
      },
      {
        id_pais: 351,
        pais: "São Martinho, Ilha de (Parte Holandesa)",
        sigla: "SX",
        codigo_ibge: "534",
        codigo_bacen: "699",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Martinho, Ilha de (Parte Holandesa)",
        value: "351"
      },
      {
        id_pais: 291,
        pais: "Sao Pedro e Miquelon",
        sigla: "SP",
        codigo_ibge: "666",
        codigo_bacen: "700",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Pedro e Miquelon",
        value: "291"
      },
      {
        id_pais: 294,
        pais: "Sao Tome e Principe, Ilhas",
        sigla: "ST",
        codigo_ibge: "678",
        codigo_bacen: "720",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Tomé e Príncipe, Ilhas",
        value: "294"
      },
      {
        id_pais: 153,
        pais: "Sao Vicente e Granadinas",
        sigla: "VC",
        codigo_ibge: "670",
        codigo_bacen: "705",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Vicente e Granadinas",
        value: "153"
      },
      {
        id_pais: 163,
        pais: "Senegal",
        sigla: "SN",
        codigo_ibge: "686",
        codigo_bacen: "728",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Senegal",
        value: "163"
      },
      {
        id_pais: 164,
        pais: "Serra Leoa",
        sigla: "SL",
        codigo_ibge: "694",
        codigo_bacen: "735",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Serra Leoa",
        value: "164"
      },
      {
        id_pais: 165,
        pais: "Servia",
        sigla: "RS",
        codigo_ibge: "688",
        codigo_bacen: "737",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Sérvia",
        value: "165"
      },
      {
        id_pais: 69,
        pais: "Seychelles",
        sigla: "SC",
        codigo_ibge: "690",
        codigo_bacen: "731",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Seychelles",
        value: "69"
      },
      {
        id_pais: 166,
        pais: "Siria, República Arabe da",
        sigla: "SY",
        codigo_ibge: "760",
        codigo_bacen: "744",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Síria, República Árabe da",
        value: "166"
      },
      {
        id_pais: 167,
        pais: "Somalia",
        sigla: "SO",
        codigo_ibge: "706",
        codigo_bacen: "748",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Somália",
        value: "167"
      },
      {
        id_pais: 168,
        pais: "Sri Lanka",
        sigla: "LK",
        codigo_ibge: "144",
        codigo_bacen: "750",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Sri Lanka",
        value: "168"
      },
      {
        id_pais: 170,
        pais: "Suazilândia",
        sigla: "SZ",
        codigo_ibge: "748",
        codigo_bacen: null,
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Suazilândia",
        value: "170"
      },
      {
        id_pais: 171,
        pais: "Sudao",
        sigla: "SD",
        codigo_ibge: "729",
        codigo_bacen: "759",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Sudão",
        value: "171"
      },
      {
        id_pais: 352,
        pais: "Sudao do Sul",
        sigla: "SS",
        codigo_ibge: "728",
        codigo_bacen: "760",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Sudão do Sul",
        value: "352"
      },
      {
        id_pais: 172,
        pais: "Suecia",
        sigla: "SE",
        codigo_ibge: "752",
        codigo_bacen: "764",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Suécia",
        value: "172"
      },
      {
        id_pais: 173,
        pais: "Suica",
        sigla: "CH",
        codigo_ibge: "756",
        codigo_bacen: "767",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Suíça",
        value: "173"
      },
      {
        id_pais: 174,
        pais: "Suriname",
        sigla: "SR",
        codigo_ibge: "740",
        codigo_bacen: "770",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Suriname",
        value: "174"
      },
      {
        id_pais: 353,
        pais: "Svalbard e Jan Mayen",
        sigla: "SJ",
        codigo_ibge: "744",
        codigo_bacen: "755",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Svalbard e Jan Mayen",
        value: "353"
      },
      {
        id_pais: 175,
        pais: "Tadjiquistao, República do",
        sigla: "TJ",
        codigo_ibge: "762",
        codigo_bacen: "772",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tadjiquistão, República do",
        value: "175"
      },
      {
        id_pais: 176,
        pais: "Tailandia",
        sigla: "TH",
        codigo_ibge: "764",
        codigo_bacen: "776",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tailândia",
        value: "176"
      },
      {
        id_pais: 178,
        pais: "Tanzania, Rep. Unida da",
        sigla: "TZ",
        codigo_ibge: "834",
        codigo_bacen: "780",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tanzânia, Rep. Unida da",
        value: "178"
      },
      {
        id_pais: 149,
        pais: "Tcheca, República",
        sigla: "CZ",
        codigo_ibge: "203",
        codigo_bacen: "791",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tcheca, República",
        value: "149"
      },
      {
        id_pais: 354,
        pais: "Terras Austrais Francesas",
        sigla: "TF",
        codigo_ibge: null,
        codigo_bacen: "781",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Terras Austrais Francesas",
        value: "354"
      },
      {
        id_pais: 295,
        pais: "Territorio Brit. Oc. Indico",
        sigla: "IO",
        codigo_ibge: null,
        codigo_bacen: "782",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Território Brit. Oc. Índico",
        value: "295"
      },
      {
        id_pais: 253,
        pais: "Timor Leste",
        sigla: "TL",
        codigo_ibge: "626",
        codigo_bacen: "795",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Timor Leste",
        value: "253"
      },
      {
        id_pais: 183,
        pais: "Togo",
        sigla: "TG",
        codigo_ibge: "768",
        codigo_bacen: "800",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Togo",
        value: "183"
      },
      {
        id_pais: 184,
        pais: "Tonga",
        sigla: "TO",
        codigo_ibge: "776",
        codigo_bacen: "810",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tonga",
        value: "184"
      },
      {
        id_pais: 296,
        pais: "Toquelau, Ilhas",
        sigla: "TK",
        codigo_ibge: "772",
        codigo_bacen: "805",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Toquelau, Ilhas",
        value: "296"
      },
      {
        id_pais: 185,
        pais: "Trinidad and Tobago",
        sigla: "TT",
        codigo_ibge: "780",
        codigo_bacen: "815",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Trinidad and Tobago",
        value: "185"
      },
      {
        id_pais: 186,
        pais: "Tunisia",
        sigla: "TN",
        codigo_ibge: "788",
        codigo_bacen: "820",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tunísia",
        value: "186"
      },
      {
        id_pais: 275,
        pais: "Turcas e Caicos, Ilhas",
        sigla: "TC",
        codigo_ibge: "796",
        codigo_bacen: "823",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Turcas e Caicos, Ilhas",
        value: "275"
      },
      {
        id_pais: 187,
        pais: "Turcomenistao, República do",
        sigla: "TM",
        codigo_ibge: "795",
        codigo_bacen: "824",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Turcomenistão, República do",
        value: "187"
      },
      {
        id_pais: 188,
        pais: "Turquía",
        sigla: "TR",
        codigo_ibge: "792",
        codigo_bacen: "827",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Turquia",
        value: "188"
      },
      {
        id_pais: 297,
        pais: "Tuvalu",
        sigla: "TV",
        codigo_ibge: "798",
        codigo_bacen: "828",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tuvalu",
        value: "297"
      },
      {
        id_pais: 190,
        pais: "Ucrânia",
        sigla: "UA",
        codigo_ibge: "804",
        codigo_bacen: "831",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Ucrania",
        value: "190"
      },
      {
        id_pais: 191,
        pais: "Uganda",
        sigla: "UG",
        codigo_ibge: "800",
        codigo_bacen: "833",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Uganda",
        value: "191"
      },
      {
        id_pais: 192,
        pais: "Uruguai",
        sigla: "UY",
        codigo_ibge: "858",
        codigo_bacen: "845",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Uruguai",
        value: "192"
      },
      {
        id_pais: 193,
        pais: "Uzbequistao, República do",
        sigla: "UZ",
        codigo_ibge: "860",
        codigo_bacen: "847",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Uzbequistão, República do",
        value: "193"
      },
      {
        id_pais: 194,
        pais: "Vanuatu",
        sigla: "VU",
        codigo_ibge: "548",
        codigo_bacen: "881",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Vanuatu",
        value: "194"
      },
      {
        id_pais: 298,
        pais: "Vaticano, Est. da Cidade do",
        sigla: "VA",
        codigo_ibge: "336",
        codigo_bacen: "848",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Vaticano, Est. da Cidade do",
        value: "298"
      },
      {
        id_pais: 196,
        pais: "Venezuela",
        sigla: "VE",
        codigo_ibge: "862",
        codigo_bacen: "850",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Venezuela",
        value: "196"
      },
      {
        id_pais: 197,
        pais: "Vietna",
        sigla: "VN",
        codigo_ibge: "704",
        codigo_bacen: "858",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Vietnã",
        value: "197"
      },
      {
        id_pais: 276,
        pais: "Virgens, ilhas (Britanicas)",
        sigla: "VG",
        codigo_ibge: "92",
        codigo_bacen: "863",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Virgens, ilhas (Britânicas)",
        value: "276"
      },
      {
        id_pais: 277,
        pais: "Virgens, Ilhas (E.U.A)",
        sigla: "VI",
        codigo_ibge: "850",
        codigo_bacen: "866",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Virgens, Ilhas (E.U.A)",
        value: "277"
      },
      {
        id_pais: 265,
        pais: "Wake, Ilha",
        sigla: "IW",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Wake, Ilha",
        value: "265"
      },
      {
        id_pais: 278,
        pais: "Wallis e Futuna, Ilhas",
        sigla: "WF",
        codigo_ibge: "876",
        codigo_bacen: "875",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Wallis e Futuna, Ilhas",
        value: "278"
      },
      {
        id_pais: 198,
        pais: "Zambia",
        sigla: "ZM",
        codigo_ibge: "894",
        codigo_bacen: "890",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Zambia",
        value: "198"
      },
      {
        id_pais: 199,
        pais: "Zimbabue",
        sigla: "ZW",
        codigo_ibge: "716",
        codigo_bacen: "665",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Zimbábue",
        value: "199"
      }
    ]
  },
  pais_destino: {
    id_tipo_filtro: "13",
    descricao: "pais destino",
    tipo_campo: "select",
    html_id: "pais_destino",
    dependencia_count: "1",
    valores: [
      {
        id_pais: 327,
        pais: "A Designar",
        sigla: "AD",
        codigo_ibge: null,
        codigo_bacen: "994",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "A Designar",
        value: "327"
      },
      {
        id_pais: 1,
        pais: "Afeganistao",
        sigla: "AF",
        codigo_ibge: "4",
        codigo_bacen: "13",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Afeganistão",
        value: "1"
      },
      {
        id_pais: 2,
        pais: "Africa do Sul",
        sigla: "ZA",
        codigo_ibge: "710",
        codigo_bacen: "756",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "África do Sul",
        value: "2"
      },
      {
        id_pais: 328,
        pais: "Aland, Ilhas",
        sigla: "AI",
        codigo_ibge: "248",
        codigo_bacen: "15",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Aland, Ilhas",
        value: "328"
      },
      {
        id_pais: 3,
        pais: "Albania",
        sigla: "AL",
        codigo_ibge: "8",
        codigo_bacen: "17",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Albânia",
        value: "3"
      },
      {
        id_pais: 4,
        pais: "Alemanha",
        sigla: "DE",
        codigo_ibge: "276",
        codigo_bacen: "23",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Alemanha",
        value: "4"
      },
      {
        id_pais: 5,
        pais: "Andorra",
        sigla: "AD",
        codigo_ibge: "20",
        codigo_bacen: "37",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Andorra",
        value: "5"
      },
      {
        id_pais: 6,
        pais: "Angola",
        sigla: "AO",
        codigo_ibge: "24",
        codigo_bacen: "40",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Angola",
        value: "6"
      },
      {
        id_pais: 254,
        pais: "Anguilla",
        sigla: "AI",
        codigo_ibge: "660",
        codigo_bacen: "41",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Anguilla",
        value: "254"
      },
      {
        id_pais: 329,
        pais: "Antártica",
        sigla: "AQ",
        codigo_ibge: null,
        codigo_bacen: "42",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Antártica",
        value: "329"
      },
      {
        id_pais: 9,
        pais: "Antígua e Barbuda",
        sigla: "AG",
        codigo_ibge: "28",
        codigo_bacen: "43",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Antígua e Barbuda",
        value: "9"
      },
      {
        id_pais: 255,
        pais: "Antilhas Holandesas ",
        sigla: "AN",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Antilhas Holandesas ",
        value: "255"
      },
      {
        id_pais: 11,
        pais: "Arábia Saudita",
        sigla: "SA",
        codigo_ibge: "682",
        codigo_bacen: "53",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Arábia Saudita",
        value: "11"
      },
      {
        id_pais: 12,
        pais: "Argelia",
        sigla: "DZ",
        codigo_ibge: "12",
        codigo_bacen: "59",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Argélia",
        value: "12"
      },
      {
        id_pais: 13,
        pais: "Argentina",
        sigla: "AR",
        codigo_ibge: "32",
        codigo_bacen: "63",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Argentina",
        value: "13"
      },
      {
        id_pais: 14,
        pais: "Armenia, República da",
        sigla: "AM",
        codigo_ibge: "51",
        codigo_bacen: "64",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Armênia, República da",
        value: "14"
      },
      {
        id_pais: 256,
        pais: "Aruba",
        sigla: "AW",
        codigo_ibge: "533",
        codigo_bacen: "65",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Aruba",
        value: "256"
      },
      {
        id_pais: 16,
        pais: "Australia",
        sigla: "AU",
        codigo_ibge: "36",
        codigo_bacen: "69",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Austrália",
        value: "16"
      },
      {
        id_pais: 17,
        pais: "Austria",
        sigla: "AT",
        codigo_ibge: "40",
        codigo_bacen: "72",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Áustria",
        value: "17"
      },
      {
        id_pais: 18,
        pais: "Azerbaijao, República do",
        sigla: "AZ",
        codigo_ibge: "31",
        codigo_bacen: "73",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Azerbaijão, República do",
        value: "18"
      },
      {
        id_pais: 19,
        pais: "Bahamas, Ilhas",
        sigla: "BS",
        codigo_ibge: "44",
        codigo_bacen: "77",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bahamas, Ilhas",
        value: "19"
      },
      {
        id_pais: 20,
        pais: "Bahrein, Ilhas",
        sigla: "BH",
        codigo_ibge: "48",
        codigo_bacen: "80",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bahrein, Ilhas",
        value: "20"
      },
      {
        id_pais: 330,
        pais: "Bancos Centrais",
        sigla: "BC",
        codigo_ibge: null,
        codigo_bacen: "995",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bancos Centrais",
        value: "330"
      },
      {
        id_pais: 21,
        pais: "Bangladesh",
        sigla: "BD",
        codigo_ibge: "50",
        codigo_bacen: "81",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bangladesh",
        value: "21"
      },
      {
        id_pais: 22,
        pais: "Barbados",
        sigla: "BB",
        codigo_ibge: "52",
        codigo_bacen: "83",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Barbados",
        value: "22"
      },
      {
        id_pais: 23,
        pais: "Belarus, República da",
        sigla: "BY",
        codigo_ibge: null,
        codigo_bacen: "85",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Belarus, República da",
        value: "23"
      },
      {
        id_pais: 24,
        pais: "Belgica",
        sigla: "BE",
        codigo_ibge: "56",
        codigo_bacen: "87",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bélgica",
        value: "24"
      },
      {
        id_pais: 25,
        pais: "Belize",
        sigla: "BZ",
        codigo_ibge: "84",
        codigo_bacen: "88",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Belize",
        value: "25"
      },
      {
        id_pais: 26,
        pais: "Benin",
        sigla: "BJ",
        codigo_ibge: "204",
        codigo_bacen: "229",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Benin",
        value: "26"
      },
      {
        id_pais: 27,
        pais: "Bermudas",
        sigla: "BM",
        codigo_ibge: "60",
        codigo_bacen: "90",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bermudas",
        value: "27"
      },
      {
        id_pais: 331,
        pais: "Bielorussia",
        sigla: "BO",
        codigo_ibge: "112",
        codigo_bacen: null,
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bielorússia",
        value: "331"
      },
      {
        id_pais: 28,
        pais: "Bolivia, Estado Plurinacional da",
        sigla: "BO",
        codigo_ibge: "68",
        codigo_bacen: "97",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bolívia, Estado Plurinacional da",
        value: "28"
      },
      {
        id_pais: 332,
        pais: "Bonaire, Saint Eustatius e Saba",
        sigla: "BQ",
        codigo_ibge: "535",
        codigo_bacen: "99",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bonaire, Saint Eustatius e Saba",
        value: "332"
      },
      {
        id_pais: 29,
        pais: "Bosnia-Herzegovina (República da)",
        sigla: "BA",
        codigo_ibge: "70",
        codigo_bacen: "98",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bósnia-Herzegovina (República da)",
        value: "29"
      },
      {
        id_pais: 30,
        pais: "Botsuana",
        sigla: "BW",
        codigo_ibge: "72",
        codigo_bacen: "101",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Botsuana",
        value: "30"
      },
      {
        id_pais: 333,
        pais: "Bouvet, Ilha",
        sigla: "BV",
        codigo_ibge: null,
        codigo_bacen: "102",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bouvet, Ilha",
        value: "333"
      },
      {
        id_pais: 32,
        pais: "Brunei",
        sigla: "BN",
        codigo_ibge: "96",
        codigo_bacen: "108",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Brunei",
        value: "32"
      },
      {
        id_pais: 33,
        pais: "Bulgaria, República da",
        sigla: "BG",
        codigo_ibge: "400",
        codigo_bacen: "111",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Bulgária, República da",
        value: "33"
      },
      {
        id_pais: 34,
        pais: "Burkina Faso",
        sigla: "BF",
        codigo_ibge: "854",
        codigo_bacen: "31",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Burkina Faso",
        value: "34"
      },
      {
        id_pais: 35,
        pais: "Burundi",
        sigla: "BI",
        codigo_ibge: "108",
        codigo_bacen: "115",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Burundi",
        value: "35"
      },
      {
        id_pais: 36,
        pais: "Butao",
        sigla: "BT",
        codigo_ibge: "64",
        codigo_bacen: "119",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Butão",
        value: "36"
      },
      {
        id_pais: 37,
        pais: "Cabo Verde, República de",
        sigla: "CV",
        codigo_ibge: "132",
        codigo_bacen: "127",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cabo Verde, República de",
        value: "37"
      },
      {
        id_pais: 38,
        pais: "Camaroes",
        sigla: "CM",
        codigo_ibge: "120",
        codigo_bacen: "145",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Camarões",
        value: "38"
      },
      {
        id_pais: 39,
        pais: "Camboja",
        sigla: "KH",
        codigo_ibge: "116",
        codigo_bacen: "141",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Camboja",
        value: "39"
      },
      {
        id_pais: 40,
        pais: "Canada",
        sigla: "CA",
        codigo_ibge: "124",
        codigo_bacen: "149",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Canadá",
        value: "40"
      },
      {
        id_pais: 266,
        pais: "Canárias, Ilhas",
        sigla: "CS",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Canárias, Ilhas",
        value: "266"
      },
      {
        id_pais: 144,
        pais: "Catar",
        sigla: "QA",
        codigo_ibge: "634",
        codigo_bacen: "154",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Catar",
        value: "144"
      },
      {
        id_pais: 57,
        pais: "Cayman, Ilhas",
        sigla: "KY",
        codigo_ibge: "136",
        codigo_bacen: "137",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cayman, Ilhas",
        value: "57"
      },
      {
        id_pais: 41,
        pais: "Cazaquistao, República do",
        sigla: "KZ",
        codigo_ibge: "398",
        codigo_bacen: "153",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cazaquistão, República do",
        value: "41"
      },
      {
        id_pais: 42,
        pais: "Chade",
        sigla: "TD",
        codigo_ibge: "148",
        codigo_bacen: "788",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Chade",
        value: "42"
      },
      {
        id_pais: 43,
        pais: "Chile",
        sigla: "CL",
        codigo_ibge: "152",
        codigo_bacen: "158",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Chile",
        value: "43"
      },
      {
        id_pais: 44,
        pais: "China",
        sigla: "CN",
        codigo_ibge: "156",
        codigo_bacen: "160",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "China",
        value: "44"
      },
      {
        id_pais: 45,
        pais: "Chipre",
        sigla: "CY",
        codigo_ibge: "196",
        codigo_bacen: "163",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Chipre",
        value: "45"
      },
      {
        id_pais: 263,
        pais: "Christmas, Ilha (Navidad)",
        sigla: "CX",
        codigo_ibge: null,
        codigo_bacen: "511",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Christmas, Ilha (Navidad)",
        value: "263"
      },
      {
        id_pais: 46,
        pais: "Cingapura",
        sigla: "SG",
        codigo_ibge: "702",
        codigo_bacen: "741",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cingapura",
        value: "46"
      },
      {
        id_pais: 267,
        pais: "Cocos (Keeling), Ilhas",
        sigla: "CC",
        codigo_ibge: null,
        codigo_bacen: "165",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cocos (Keeling), Ilhas",
        value: "267"
      },
      {
        id_pais: 47,
        pais: "Colombia",
        sigla: "CO",
        codigo_ibge: "170",
        codigo_bacen: "169",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Colômbia",
        value: "47"
      },
      {
        id_pais: 257,
        pais: "Comores, Ilhas",
        sigla: "KM",
        codigo_ibge: "174",
        codigo_bacen: "173",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Comores, Ilhas",
        value: "257"
      },
      {
        id_pais: 48,
        pais: "Congo",
        sigla: "CG",
        codigo_ibge: "178",
        codigo_bacen: "177",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Congo",
        value: "48"
      },
      {
        id_pais: 147,
        pais: "Congo, República Democratica do",
        sigla: "CD",
        codigo_ibge: "180",
        codigo_bacen: "888",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Congo, República Democratica do",
        value: "147"
      },
      {
        id_pais: 268,
        pais: "Cook, Ilhas",
        sigla: "CK",
        codigo_ibge: "184",
        codigo_bacen: "183",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cook, Ilhas",
        value: "268"
      },
      {
        id_pais: 49,
        pais: "Coreia (do Norte), Rep. Pop. Democratica",
        sigla: "KP",
        codigo_ibge: "408",
        codigo_bacen: "187",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Coréia (do Norte), Rep. Pop. Democrática",
        value: "49"
      },
      {
        id_pais: 50,
        pais: "Coreia (do Sul), República da",
        sigla: "KR",
        codigo_ibge: "410",
        codigo_bacen: "190",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Coréia (do Sul), República da",
        value: "50"
      },
      {
        id_pais: 51,
        pais: "Costa do Marfim",
        sigla: "CI",
        codigo_ibge: "384",
        codigo_bacen: "193",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Costa do Marfim",
        value: "51"
      },
      {
        id_pais: 201,
        pais: "Costa Rica",
        sigla: "CR",
        codigo_ibge: "188",
        codigo_bacen: "196",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Costa Rica",
        value: "201"
      },
      {
        id_pais: 334,
        pais: "Coveite",
        sigla: null,
        codigo_ibge: null,
        codigo_bacen: "198",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Coveite",
        value: "334"
      },
      {
        id_pais: 224,
        pais: "Croacia (República da)",
        sigla: "HR",
        codigo_ibge: "191",
        codigo_bacen: "195",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Croácia (República da)",
        value: "224"
      },
      {
        id_pais: 202,
        pais: "Cuba",
        sigla: "CU",
        codigo_ibge: "192",
        codigo_bacen: "199",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Cuba",
        value: "202"
      },
      {
        id_pais: 335,
        pais: "Curacao",
        sigla: "CW",
        codigo_ibge: "531",
        codigo_bacen: "200",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Curaçao",
        value: "335"
      },
      {
        id_pais: 225,
        pais: "Dinamarca",
        sigla: "DK",
        codigo_ibge: "208",
        codigo_bacen: "232",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Dinamarca",
        value: "225"
      },
      {
        id_pais: 226,
        pais: "Djibuti",
        sigla: "DJ",
        codigo_ibge: "262",
        codigo_bacen: "783",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Djibuti",
        value: "226"
      },
      {
        id_pais: 203,
        pais: "Dominica, Ilha",
        sigla: "DM",
        codigo_ibge: "212",
        codigo_bacen: "235",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Dominica, Ilha",
        value: "203"
      },
      {
        id_pais: 227,
        pais: "Egito",
        sigla: "EG",
        codigo_ibge: "818",
        codigo_bacen: "240",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Egito",
        value: "227"
      },
      {
        id_pais: 211,
        pais: "El Salvador",
        sigla: "SV",
        codigo_ibge: "222",
        codigo_bacen: "687",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "El Salvador",
        value: "211"
      },
      {
        id_pais: 213,
        pais: "Emirados Arabes Unidos",
        sigla: "AE",
        codigo_ibge: "784",
        codigo_bacen: "244",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Emirados Árabes Unidos",
        value: "213"
      },
      {
        id_pais: 204,
        pais: "Equador",
        sigla: "EC",
        codigo_ibge: "218",
        codigo_bacen: "239",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Equador",
        value: "204"
      },
      {
        id_pais: 228,
        pais: "Eritreia",
        sigla: "ER",
        codigo_ibge: "232",
        codigo_bacen: "243",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Eritreia",
        value: "228"
      },
      {
        id_pais: 258,
        pais: "Escócia",
        sigla: "TS",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Escócia",
        value: "258"
      },
      {
        id_pais: 230,
        pais: "Eslovaca, República",
        sigla: "SK",
        codigo_ibge: "703",
        codigo_bacen: "247",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Eslovaca, República",
        value: "230"
      },
      {
        id_pais: 231,
        pais: "Eslovenia, República da",
        sigla: "SI",
        codigo_ibge: "705",
        codigo_bacen: "246",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Eslovênia, República da",
        value: "231"
      },
      {
        id_pais: 232,
        pais: "Espanha",
        sigla: "ES",
        codigo_ibge: "724",
        codigo_bacen: "245",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Espanha",
        value: "232"
      },
      {
        id_pais: 233,
        pais: "Estados Unidos",
        sigla: "US",
        codigo_ibge: "840",
        codigo_bacen: "249",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Estados Unidos",
        value: "233"
      },
      {
        id_pais: 234,
        pais: "Estonia, República da",
        sigla: "EE",
        codigo_ibge: "233",
        codigo_bacen: "251",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Estônia, República da",
        value: "234"
      },
      {
        id_pais: 336,
        pais: "Eswatini",
        sigla: null,
        codigo_ibge: null,
        codigo_bacen: "754",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Eswatini",
        value: "336"
      },
      {
        id_pais: 235,
        pais: "Etiopia",
        sigla: "ET",
        codigo_ibge: "231",
        codigo_bacen: "253",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Etiópia",
        value: "235"
      },
      {
        id_pais: 271,
        pais: "Falkland (Ilhas Malvinas)",
        sigla: "FK",
        codigo_ibge: "238",
        codigo_bacen: "255",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Falkland (Ilhas Malvinas)",
        value: "271"
      },
      {
        id_pais: 269,
        pais: "Feroe, Ilhas",
        sigla: "FO",
        codigo_ibge: "234",
        codigo_bacen: "259",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Feroe, Ilhas",
        value: "269"
      },
      {
        id_pais: 237,
        pais: "Fiji",
        sigla: "FJ",
        codigo_ibge: "242",
        codigo_bacen: "870",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Fiji",
        value: "237"
      },
      {
        id_pais: 238,
        pais: "Filipinas",
        sigla: "PH",
        codigo_ibge: "608",
        codigo_bacen: "267",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Filipinas",
        value: "238"
      },
      {
        id_pais: 239,
        pais: "Finlandia",
        sigla: "FI",
        codigo_ibge: "246",
        codigo_bacen: "271",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Finlândia",
        value: "239"
      },
      {
        id_pais: 177,
        pais: "Formosa (Taiwan)",
        sigla: "TW",
        codigo_ibge: null,
        codigo_bacen: "161",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Formosa (Taiwan)",
        value: "177"
      },
      {
        id_pais: 240,
        pais: "Franca",
        sigla: "FR",
        codigo_ibge: "250",
        codigo_bacen: "275",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Franca",
        value: "240"
      },
      {
        id_pais: 241,
        pais: "Gabao",
        sigla: "GA",
        codigo_ibge: "266",
        codigo_bacen: "281",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Gabão",
        value: "241"
      },
      {
        id_pais: 206,
        pais: "Gambia",
        sigla: "GM",
        codigo_ibge: "270",
        codigo_bacen: "285",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Gâmbia",
        value: "206"
      },
      {
        id_pais: 243,
        pais: "Gana",
        sigla: "GH",
        codigo_ibge: "288",
        codigo_bacen: "289",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Gana",
        value: "243"
      },
      {
        id_pais: 337,
        pais: "Geórgia do Sul e Sandwich do Sul, Ilhas",
        sigla: "GS",
        codigo_ibge: null,
        codigo_bacen: "292",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Geórgia do Sul e Sandwich do Sul, Ilhas",
        value: "337"
      },
      {
        id_pais: 242,
        pais: "Georgia, República da",
        sigla: "GE",
        codigo_ibge: "268",
        codigo_bacen: "291",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Geórgia, República da",
        value: "242"
      },
      {
        id_pais: 259,
        pais: "Gibraltar",
        sigla: "GI",
        codigo_ibge: "292",
        codigo_bacen: "293",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Gibraltar",
        value: "259"
      },
      {
        id_pais: 205,
        pais: "Granada",
        sigla: "GD",
        codigo_ibge: "308",
        codigo_bacen: "297",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Granada",
        value: "205"
      },
      {
        id_pais: 245,
        pais: "Grecia",
        sigla: "GR",
        codigo_ibge: "300",
        codigo_bacen: "301",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Grécia",
        value: "245"
      },
      {
        id_pais: 338,
        pais: "Groenlandia",
        sigla: "GL",
        codigo_ibge: "304",
        codigo_bacen: "305",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Groenlândia",
        value: "338"
      },
      {
        id_pais: 339,
        pais: "Guadalupe",
        sigla: "GP",
        codigo_ibge: "312",
        codigo_bacen: "309",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guadalupe",
        value: "339"
      },
      {
        id_pais: 340,
        pais: "Guam",
        sigla: "GU",
        codigo_ibge: "316",
        codigo_bacen: "313",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guam",
        value: "340"
      },
      {
        id_pais: 207,
        pais: "Guatemala",
        sigla: "GT",
        codigo_ibge: "320",
        codigo_bacen: "317",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guatemala",
        value: "207"
      },
      {
        id_pais: 341,
        pais: "Guernsey",
        sigla: "GG",
        codigo_ibge: "831",
        codigo_bacen: "321",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guernsey",
        value: "341"
      },
      {
        id_pais: 208,
        pais: "Guiana",
        sigla: "GY",
        codigo_ibge: "328",
        codigo_bacen: "337",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guiana",
        value: "208"
      },
      {
        id_pais: 212,
        pais: "Guiana Francesa",
        sigla: "GF",
        codigo_ibge: "254",
        codigo_bacen: "325",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guiana Francesa",
        value: "212"
      },
      {
        id_pais: 249,
        pais: "Guine",
        sigla: "GN",
        codigo_ibge: "324",
        codigo_bacen: "329",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guine",
        value: "249"
      },
      {
        id_pais: 215,
        pais: "Guine-Bissau",
        sigla: "GW",
        codigo_ibge: "624",
        codigo_bacen: "334",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guine-Bissau",
        value: "215"
      },
      {
        id_pais: 216,
        pais: "Guine-Equatorial",
        sigla: "GQ",
        codigo_ibge: "226",
        codigo_bacen: "331",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Guine-Equatorial",
        value: "216"
      },
      {
        id_pais: 210,
        pais: "Haiti",
        sigla: "HT",
        codigo_ibge: "332",
        codigo_bacen: "341",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Haiti",
        value: "210"
      },
      {
        id_pais: 342,
        pais: "Heard e Ilhas McDonald, Ilha",
        sigla: "HM",
        codigo_ibge: null,
        codigo_bacen: "343",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Heard e Ilhas McDonald, Ilha",
        value: "342"
      },
      {
        id_pais: 209,
        pais: "Honduras",
        sigla: "HN",
        codigo_ibge: "340",
        codigo_bacen: "345",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Honduras",
        value: "209"
      },
      {
        id_pais: 218,
        pais: "Hong Kong",
        sigla: "HK",
        codigo_ibge: "344",
        codigo_bacen: "351",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Hong Kong",
        value: "218"
      },
      {
        id_pais: 219,
        pais: "Hungria, República da",
        sigla: "HU",
        codigo_ibge: "348",
        codigo_bacen: "355",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Hungria, República da",
        value: "219"
      },
      {
        id_pais: 220,
        pais: "Iemen",
        sigla: "YE",
        codigo_ibge: "887",
        codigo_bacen: "357",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Iemen",
        value: "220"
      },
      {
        id_pais: 77,
        pais: "India",
        sigla: "IN",
        codigo_ibge: "356",
        codigo_bacen: "361",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Índia",
        value: "77"
      },
      {
        id_pais: 78,
        pais: "Indonesia",
        sigla: "ID",
        codigo_ibge: "360",
        codigo_bacen: "365",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Indonésia",
        value: "78"
      },
      {
        id_pais: 279,
        pais: "Inglaterra",
        sigla: "GB",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Inglaterra",
        value: "279"
      },
      {
        id_pais: 79,
        pais: "Ira, República Islamica do",
        sigla: "IR",
        codigo_ibge: "364",
        codigo_bacen: "372",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Ira, República Islamica do",
        value: "79"
      },
      {
        id_pais: 80,
        pais: "Iraque",
        sigla: "IQ",
        codigo_ibge: "368",
        codigo_bacen: "369",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Iraque",
        value: "80"
      },
      {
        id_pais: 81,
        pais: "Irlanda",
        sigla: "IE",
        codigo_ibge: "372",
        codigo_bacen: "375",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Irlanda",
        value: "81"
      },
      {
        id_pais: 82,
        pais: "Islandia",
        sigla: "IS",
        codigo_ibge: "352",
        codigo_bacen: "379",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Islândia",
        value: "82"
      },
      {
        id_pais: 83,
        pais: "Israel",
        sigla: "IL",
        codigo_ibge: "376",
        codigo_bacen: "383",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Israel",
        value: "83"
      },
      {
        id_pais: 84,
        pais: "Italia",
        sigla: "IT",
        codigo_ibge: "380",
        codigo_bacen: "386",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Itália",
        value: "84"
      },
      {
        id_pais: 85,
        pais: "Jamaica",
        sigla: "JM",
        codigo_ibge: "388",
        codigo_bacen: "391",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Jamaica",
        value: "85"
      },
      {
        id_pais: 86,
        pais: "Japao",
        sigla: "JP",
        codigo_ibge: "392",
        codigo_bacen: "399",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Japão",
        value: "86"
      },
      {
        id_pais: 343,
        pais: "Jersey",
        sigla: "JE",
        codigo_ibge: "832",
        codigo_bacen: "393",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Jersey",
        value: "343"
      },
      {
        id_pais: 270,
        pais: "Johnston, Ilhas",
        sigla: "IJ",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Johnston, Ilhas",
        value: "270"
      },
      {
        id_pais: 88,
        pais: "Jordania",
        sigla: "JO",
        codigo_ibge: "400",
        codigo_bacen: "403",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Jordânia",
        value: "88"
      },
      {
        id_pais: 90,
        pais: "Kiribati",
        sigla: "KI",
        codigo_ibge: "296",
        codigo_bacen: "411",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Kiribati",
        value: "90"
      },
      {
        id_pais: 91,
        pais: "Kuwait",
        sigla: "KW",
        codigo_ibge: "414",
        codigo_bacen: null,
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Kuwait",
        value: "91"
      },
      {
        id_pais: 280,
        pais: "Labuão (Lebuan)",
        sigla: "LN",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Labuão (Lebuan)",
        value: "280"
      },
      {
        id_pais: 92,
        pais: "Laos, Rep. Pop. Democr. do",
        sigla: "LA",
        codigo_ibge: "418",
        codigo_bacen: "420",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Laos, Rep. Pop. Democr. do",
        value: "92"
      },
      {
        id_pais: 94,
        pais: "Lesoto",
        sigla: "LS",
        codigo_ibge: "426",
        codigo_bacen: "426",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Lesoto",
        value: "94"
      },
      {
        id_pais: 281,
        pais: "Letônia (Latvia)",
        sigla: "LV",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Letônia (Latvia)",
        value: "281"
      },
      {
        id_pais: 93,
        pais: "Letonia, República da",
        sigla: "LV",
        codigo_ibge: "428",
        codigo_bacen: "427",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Letônia, República da",
        value: "93"
      },
      {
        id_pais: 95,
        pais: "Libano",
        sigla: "LB",
        codigo_ibge: "422",
        codigo_bacen: "431",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Líbano",
        value: "95"
      },
      {
        id_pais: 96,
        pais: "Liberia",
        sigla: "LR",
        codigo_ibge: "430",
        codigo_bacen: "434",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Liberia",
        value: "96"
      },
      {
        id_pais: 97,
        pais: "Libia",
        sigla: "LY",
        codigo_ibge: "434",
        codigo_bacen: "438",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Líbia",
        value: "97"
      },
      {
        id_pais: 98,
        pais: "Liechtenstein",
        sigla: "LI",
        codigo_ibge: "438",
        codigo_bacen: "440",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Liechtenstein",
        value: "98"
      },
      {
        id_pais: 99,
        pais: "Lituania, República da",
        sigla: "LT",
        codigo_ibge: "440",
        codigo_bacen: "442",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Lituânia, República da",
        value: "99"
      },
      {
        id_pais: 100,
        pais: "Luxemburgo",
        sigla: "LU",
        codigo_ibge: "442",
        codigo_bacen: "445",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Luxemburgo",
        value: "100"
      },
      {
        id_pais: 101,
        pais: "Macau",
        sigla: "MO",
        codigo_ibge: "446",
        codigo_bacen: "447",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Macau",
        value: "101"
      },
      {
        id_pais: 102,
        pais: "Macedonia, Ant. Rep. Iugoslava",
        sigla: "MK",
        codigo_ibge: "807",
        codigo_bacen: "449",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Macedônia, Ant. Rep. Iugoslava",
        value: "102"
      },
      {
        id_pais: 103,
        pais: "Madagascar",
        sigla: "MG",
        codigo_ibge: "450",
        codigo_bacen: "450",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Madagascar",
        value: "103"
      },
      {
        id_pais: 260,
        pais: "Madeira, Ilha da",
        sigla: "WI",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Madeira, Ilha da",
        value: "260"
      },
      {
        id_pais: 104,
        pais: "Malasia",
        sigla: "MY",
        codigo_ibge: "458",
        codigo_bacen: "455",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Malásia",
        value: "104"
      },
      {
        id_pais: 105,
        pais: "Malavi",
        sigla: "MW",
        codigo_ibge: "454",
        codigo_bacen: "458",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Malavi",
        value: "105"
      },
      {
        id_pais: 106,
        pais: "Maldivas",
        sigla: "MV",
        codigo_ibge: "462",
        codigo_bacen: "461",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Maldivas",
        value: "106"
      },
      {
        id_pais: 107,
        pais: "Mali",
        sigla: "ML",
        codigo_ibge: "466",
        codigo_bacen: "464",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mali",
        value: "107"
      },
      {
        id_pais: 108,
        pais: "Malta",
        sigla: "MT",
        codigo_ibge: "470",
        codigo_bacen: "467",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Malta",
        value: "108"
      },
      {
        id_pais: 262,
        pais: "Man, Ilha de",
        sigla: "IM",
        codigo_ibge: "833",
        codigo_bacen: "359",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Man, Ilha de",
        value: "262"
      },
      {
        id_pais: 272,
        pais: "Marianas do Norte",
        sigla: "MP",
        codigo_ibge: "580",
        codigo_bacen: "472",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Marianas do Norte",
        value: "272"
      },
      {
        id_pais: 109,
        pais: "Marrocos",
        sigla: "MA",
        codigo_ibge: "504",
        codigo_bacen: "474",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Marrocos",
        value: "109"
      },
      {
        id_pais: 273,
        pais: "Marshall, Ilhas",
        sigla: "MH",
        codigo_ibge: "584",
        codigo_bacen: "476",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Marshall, Ilhas",
        value: "273"
      },
      {
        id_pais: 282,
        pais: "Martinica",
        sigla: "MQ",
        codigo_ibge: "474",
        codigo_bacen: "477",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Martinica",
        value: "282"
      },
      {
        id_pais: 111,
        pais: "Mauricio",
        sigla: "MU",
        codigo_ibge: "480",
        codigo_bacen: "485",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Maurício",
        value: "111"
      },
      {
        id_pais: 112,
        pais: "Mauritania",
        sigla: "MR",
        codigo_ibge: "478",
        codigo_bacen: "488",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mauritânia",
        value: "112"
      },
      {
        id_pais: 344,
        pais: "Mayotte",
        sigla: "YT",
        codigo_ibge: "175",
        codigo_bacen: "489",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mayotte",
        value: "344"
      },
      {
        id_pais: 114,
        pais: "Mexico",
        sigla: "MX",
        codigo_ibge: "484",
        codigo_bacen: "493",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "México",
        value: "114"
      },
      {
        id_pais: 122,
        pais: "Mianmar (Birmania)",
        sigla: "MM",
        codigo_ibge: "104",
        codigo_bacen: "93",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mianmar (Birmania)",
        value: "122"
      },
      {
        id_pais: 283,
        pais: "Micronesia",
        sigla: "FM",
        codigo_ibge: "583",
        codigo_bacen: "499",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Micronésia",
        value: "283"
      },
      {
        id_pais: 274,
        pais: "Midway, Ilhas",
        sigla: "MI",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Midway, Ilhas",
        value: "274"
      },
      {
        id_pais: 116,
        pais: "Mocambique",
        sigla: "MZ",
        codigo_ibge: "508",
        codigo_bacen: "505",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Moçambique",
        value: "116"
      },
      {
        id_pais: 117,
        pais: "Moldovia, República da",
        sigla: "MD",
        codigo_ibge: "498",
        codigo_bacen: "494",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Moldovia, República da",
        value: "117"
      },
      {
        id_pais: 118,
        pais: "Monaco",
        sigla: "MC",
        codigo_ibge: "492",
        codigo_bacen: "495",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mônaco",
        value: "118"
      },
      {
        id_pais: 119,
        pais: "Mongolia",
        sigla: "MN",
        codigo_ibge: "496",
        codigo_bacen: "497",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mongólia",
        value: "119"
      },
      {
        id_pais: 284,
        pais: "Mont Serrat, Ilhas",
        sigla: "MS",
        codigo_ibge: "500",
        codigo_bacen: "501",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Mont Serrat, Ilhas",
        value: "284"
      },
      {
        id_pais: 120,
        pais: "Montenegro",
        sigla: "ME",
        codigo_ibge: "499",
        codigo_bacen: "498",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Montenegro",
        value: "120"
      },
      {
        id_pais: 123,
        pais: "Namibia",
        sigla: "NA",
        codigo_ibge: "516",
        codigo_bacen: "507",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Namíbia",
        value: "123"
      },
      {
        id_pais: 124,
        pais: "Nauru",
        sigla: "NR",
        codigo_ibge: "520",
        codigo_bacen: "508",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Nauru",
        value: "124"
      },
      {
        id_pais: 125,
        pais: "Nepal",
        sigla: "NP",
        codigo_ibge: "524",
        codigo_bacen: "517",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Nepal",
        value: "125"
      },
      {
        id_pais: 126,
        pais: "Nicaragua",
        sigla: "NI",
        codigo_ibge: "558",
        codigo_bacen: "521",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Nicarágua",
        value: "126"
      },
      {
        id_pais: 127,
        pais: "Niger",
        sigla: "NE",
        codigo_ibge: "562",
        codigo_bacen: "525",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Níger",
        value: "127"
      },
      {
        id_pais: 128,
        pais: "Nigeria",
        sigla: "NG",
        codigo_ibge: "566",
        codigo_bacen: "528",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Nigéria",
        value: "128"
      },
      {
        id_pais: 129,
        pais: "Niue, Ilha",
        sigla: "NU",
        codigo_ibge: "570",
        codigo_bacen: "531",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Niue, Ilha",
        value: "129"
      },
      {
        id_pais: 264,
        pais: "Norfolk, Ilha",
        sigla: "NF",
        codigo_ibge: "574",
        codigo_bacen: "535",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Norfolk, Ilha",
        value: "264"
      },
      {
        id_pais: 130,
        pais: "Noruega",
        sigla: "NO",
        codigo_ibge: "578",
        codigo_bacen: "538",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Noruega",
        value: "130"
      },
      {
        id_pais: 285,
        pais: "Nova Caledonia",
        sigla: "NC",
        codigo_ibge: "540",
        codigo_bacen: "542",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Nova Caledônia",
        value: "285"
      },
      {
        id_pais: 132,
        pais: "Nova Zelândia",
        sigla: "NZ",
        codigo_ibge: "554",
        codigo_bacen: "548",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Nova Zelândia",
        value: "132"
      },
      {
        id_pais: 133,
        pais: "Oma",
        sigla: "OM",
        codigo_ibge: "512",
        codigo_bacen: "556",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Omã",
        value: "133"
      },
      {
        id_pais: 345,
        pais: "Organizações Internacionais",
        sigla: null,
        codigo_ibge: null,
        codigo_bacen: "997",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Organizações Internacionais",
        value: "345"
      },
      {
        id_pais: 346,
        pais: "Pacifico, Ilhas do (Possesao dos EUA)",
        sigla: null,
        codigo_ibge: null,
        codigo_bacen: "566",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Pacífico, Ilhas do (Possesão dos EUA)",
        value: "346"
      },
      {
        id_pais: 286,
        pais: "País de Gales",
        sigla: "UK",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "País de Gales",
        value: "286"
      },
      {
        id_pais: 217,
        pais: "Paises Baixos (Holanda)",
        sigla: "NL",
        codigo_ibge: "528",
        codigo_bacen: "573",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Países Baixos (Holanda)",
        value: "217"
      },
      {
        id_pais: 287,
        pais: "Palau",
        sigla: "PW",
        codigo_ibge: "585",
        codigo_bacen: "575",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Palau",
        value: "287"
      },
      {
        id_pais: 347,
        pais: "Palestina",
        sigla: "PS",
        codigo_ibge: "275",
        codigo_bacen: "578",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Palestina",
        value: "347"
      },
      {
        id_pais: 135,
        pais: "Panama",
        sigla: "PA",
        codigo_ibge: "591",
        codigo_bacen: "580",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Panamá",
        value: "135"
      },
      {
        id_pais: 136,
        pais: "Papua Nova Guine",
        sigla: "PG",
        codigo_ibge: "598",
        codigo_bacen: "545",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Papua-Nova Guiné",
        value: "136"
      },
      {
        id_pais: 137,
        pais: "Paquistao",
        sigla: "PK",
        codigo_ibge: "586",
        codigo_bacen: "576",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Paquistão",
        value: "137"
      },
      {
        id_pais: 138,
        pais: "Paraguai",
        sigla: "PY",
        codigo_ibge: "600",
        codigo_bacen: "586",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Paraguai",
        value: "138"
      },
      {
        id_pais: 139,
        pais: "Peru",
        sigla: "PE",
        codigo_ibge: "604",
        codigo_bacen: "589",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Perú",
        value: "139"
      },
      {
        id_pais: 288,
        pais: "Pitcairn, Ilha",
        sigla: "PN",
        codigo_ibge: "612",
        codigo_bacen: "593",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Pitcairn, Ilha",
        value: "288"
      },
      {
        id_pais: 289,
        pais: "Polinesia Francesa",
        sigla: "PF",
        codigo_ibge: "258",
        codigo_bacen: "599",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Polinésia Francesa",
        value: "289"
      },
      {
        id_pais: 141,
        pais: "Polonia, República da",
        sigla: "PL",
        codigo_ibge: "616",
        codigo_bacen: "603",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Polônia, República da",
        value: "141"
      },
      {
        id_pais: 142,
        pais: "Porto Rico",
        sigla: "PR",
        codigo_ibge: "630",
        codigo_bacen: "611",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Porto Rico",
        value: "142"
      },
      {
        id_pais: 143,
        pais: "Portugal",
        sigla: "PT",
        codigo_ibge: "620",
        codigo_bacen: "607",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Portugal",
        value: "143"
      },
      {
        id_pais: 348,
        pais: "Provisao de Navios e Aeronaves",
        sigla: null,
        codigo_ibge: null,
        codigo_bacen: "990",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Provisão de Navios e Aeronaves",
        value: "348"
      },
      {
        id_pais: 290,
        pais: "Quênia",
        sigla: "KE",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2021-04-19 16:34:09",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Quênia",
        value: "290"
      },
      {
        id_pais: 89,
        pais: "Quenia",
        sigla: "KE",
        codigo_ibge: "404",
        codigo_bacen: "623",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Quenia",
        value: "89"
      },
      {
        id_pais: 145,
        pais: "Quirguiz, República",
        sigla: "KG",
        codigo_ibge: "417",
        codigo_bacen: "625",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Quirguiz, República",
        value: "145"
      },
      {
        id_pais: 223,
        pais: "Reino Unido",
        sigla: "GB",
        codigo_ibge: "826",
        codigo_bacen: "628",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Reino Unido",
        value: "223"
      },
      {
        id_pais: 146,
        pais: "República Centro-Africana",
        sigla: "CF",
        codigo_ibge: "140",
        codigo_bacen: "640",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "República Centro-Africana",
        value: "146"
      },
      {
        id_pais: 148,
        pais: "República Dominicana",
        sigla: "DO",
        codigo_ibge: "214",
        codigo_bacen: "647",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "República Dominicana",
        value: "148"
      },
      {
        id_pais: 261,
        pais: "Reuniao, Ilha",
        sigla: "RE",
        codigo_ibge: "638",
        codigo_bacen: "660",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Reunião, Ilha",
        value: "261"
      },
      {
        id_pais: 150,
        pais: "Romenia",
        sigla: "RO",
        codigo_ibge: "642",
        codigo_bacen: "670",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Romênia",
        value: "150"
      },
      {
        id_pais: 151,
        pais: "Ruanda",
        sigla: "RW",
        codigo_ibge: "646",
        codigo_bacen: "675",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Ruanda",
        value: "151"
      },
      {
        id_pais: 236,
        pais: "Russia, Federacao da",
        sigla: "RU",
        codigo_ibge: "643",
        codigo_bacen: "676",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Rússia, Federação da",
        value: "236"
      },
      {
        id_pais: 152,
        pais: "Saara Ocidental",
        sigla: "EH",
        codigo_ibge: "732",
        codigo_bacen: "685",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Saara Ocidental",
        value: "152"
      },
      {
        id_pais: 70,
        pais: "Salomao, Ilhas ",
        sigla: "SB",
        codigo_ibge: "90",
        codigo_bacen: "677",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Salomão, Ilhas ",
        value: "70"
      },
      {
        id_pais: 155,
        pais: "Samoa",
        sigla: "WS",
        codigo_ibge: "882",
        codigo_bacen: "690",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Samoa",
        value: "155"
      },
      {
        id_pais: 154,
        pais: "Samoa Americana",
        sigla: "AS",
        codigo_ibge: "16",
        codigo_bacen: "691",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Samoa Americana",
        value: "154"
      },
      {
        id_pais: 293,
        pais: "San Marino",
        sigla: "SM",
        codigo_ibge: "674",
        codigo_bacen: "697",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "San Marino",
        value: "293"
      },
      {
        id_pais: 292,
        pais: "Santa Helena",
        sigla: "SH",
        codigo_ibge: "654",
        codigo_bacen: "710",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Santa Helena",
        value: "292"
      },
      {
        id_pais: 158,
        pais: "Santa Lucia",
        sigla: "LC",
        codigo_ibge: "662",
        codigo_bacen: "715",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Santa Lúcia",
        value: "158"
      },
      {
        id_pais: 349,
        pais: "Sao Bartolomeu",
        sigla: "BL",
        codigo_ibge: "652",
        codigo_bacen: "693",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Bartolomeu",
        value: "349"
      },
      {
        id_pais: 160,
        pais: "Sao Cristovao e Neves, Ilhas",
        sigla: "KN",
        codigo_ibge: "659",
        codigo_bacen: "695",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Cristovão e Neves, Ilhas",
        value: "160"
      },
      {
        id_pais: 350,
        pais: "São Martinho, Ilha de (Parte Francesa)",
        sigla: "MA",
        codigo_ibge: "663",
        codigo_bacen: "698",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Martinho, Ilha de (Parte Francesa)",
        value: "350"
      },
      {
        id_pais: 351,
        pais: "São Martinho, Ilha de (Parte Holandesa)",
        sigla: "SX",
        codigo_ibge: "534",
        codigo_bacen: "699",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Martinho, Ilha de (Parte Holandesa)",
        value: "351"
      },
      {
        id_pais: 291,
        pais: "Sao Pedro e Miquelon",
        sigla: "SP",
        codigo_ibge: "666",
        codigo_bacen: "700",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Pedro e Miquelon",
        value: "291"
      },
      {
        id_pais: 294,
        pais: "Sao Tome e Principe, Ilhas",
        sigla: "ST",
        codigo_ibge: "678",
        codigo_bacen: "720",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Tomé e Príncipe, Ilhas",
        value: "294"
      },
      {
        id_pais: 153,
        pais: "Sao Vicente e Granadinas",
        sigla: "VC",
        codigo_ibge: "670",
        codigo_bacen: "705",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "São Vicente e Granadinas",
        value: "153"
      },
      {
        id_pais: 163,
        pais: "Senegal",
        sigla: "SN",
        codigo_ibge: "686",
        codigo_bacen: "728",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Senegal",
        value: "163"
      },
      {
        id_pais: 164,
        pais: "Serra Leoa",
        sigla: "SL",
        codigo_ibge: "694",
        codigo_bacen: "735",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Serra Leoa",
        value: "164"
      },
      {
        id_pais: 165,
        pais: "Servia",
        sigla: "RS",
        codigo_ibge: "688",
        codigo_bacen: "737",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Sérvia",
        value: "165"
      },
      {
        id_pais: 69,
        pais: "Seychelles",
        sigla: "SC",
        codigo_ibge: "690",
        codigo_bacen: "731",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:19",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Seychelles",
        value: "69"
      },
      {
        id_pais: 166,
        pais: "Siria, República Arabe da",
        sigla: "SY",
        codigo_ibge: "760",
        codigo_bacen: "744",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Síria, República Árabe da",
        value: "166"
      },
      {
        id_pais: 167,
        pais: "Somalia",
        sigla: "SO",
        codigo_ibge: "706",
        codigo_bacen: "748",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Somália",
        value: "167"
      },
      {
        id_pais: 168,
        pais: "Sri Lanka",
        sigla: "LK",
        codigo_ibge: "144",
        codigo_bacen: "750",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Sri Lanka",
        value: "168"
      },
      {
        id_pais: 170,
        pais: "Suazilândia",
        sigla: "SZ",
        codigo_ibge: "748",
        codigo_bacen: null,
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Suazilândia",
        value: "170"
      },
      {
        id_pais: 171,
        pais: "Sudao",
        sigla: "SD",
        codigo_ibge: "729",
        codigo_bacen: "759",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Sudão",
        value: "171"
      },
      {
        id_pais: 352,
        pais: "Sudao do Sul",
        sigla: "SS",
        codigo_ibge: "728",
        codigo_bacen: "760",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Sudão do Sul",
        value: "352"
      },
      {
        id_pais: 172,
        pais: "Suecia",
        sigla: "SE",
        codigo_ibge: "752",
        codigo_bacen: "764",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Suécia",
        value: "172"
      },
      {
        id_pais: 173,
        pais: "Suica",
        sigla: "CH",
        codigo_ibge: "756",
        codigo_bacen: "767",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Suíça",
        value: "173"
      },
      {
        id_pais: 174,
        pais: "Suriname",
        sigla: "SR",
        codigo_ibge: "740",
        codigo_bacen: "770",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Suriname",
        value: "174"
      },
      {
        id_pais: 353,
        pais: "Svalbard e Jan Mayen",
        sigla: "SJ",
        codigo_ibge: "744",
        codigo_bacen: "755",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Svalbard e Jan Mayen",
        value: "353"
      },
      {
        id_pais: 175,
        pais: "Tadjiquistao, República do",
        sigla: "TJ",
        codigo_ibge: "762",
        codigo_bacen: "772",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tadjiquistão, República do",
        value: "175"
      },
      {
        id_pais: 176,
        pais: "Tailandia",
        sigla: "TH",
        codigo_ibge: "764",
        codigo_bacen: "776",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tailândia",
        value: "176"
      },
      {
        id_pais: 178,
        pais: "Tanzania, Rep. Unida da",
        sigla: "TZ",
        codigo_ibge: "834",
        codigo_bacen: "780",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tanzânia, Rep. Unida da",
        value: "178"
      },
      {
        id_pais: 149,
        pais: "Tcheca, República",
        sigla: "CZ",
        codigo_ibge: "203",
        codigo_bacen: "791",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tcheca, República",
        value: "149"
      },
      {
        id_pais: 354,
        pais: "Terras Austrais Francesas",
        sigla: "TF",
        codigo_ibge: null,
        codigo_bacen: "781",
        created_at: "2022-09-14 10:06:20",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Terras Austrais Francesas",
        value: "354"
      },
      {
        id_pais: 295,
        pais: "Territorio Brit. Oc. Indico",
        sigla: "IO",
        codigo_ibge: null,
        codigo_bacen: "782",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Território Brit. Oc. Índico",
        value: "295"
      },
      {
        id_pais: 253,
        pais: "Timor Leste",
        sigla: "TL",
        codigo_ibge: "626",
        codigo_bacen: "795",
        created_at: null,
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Timor Leste",
        value: "253"
      },
      {
        id_pais: 183,
        pais: "Togo",
        sigla: "TG",
        codigo_ibge: "768",
        codigo_bacen: "800",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Togo",
        value: "183"
      },
      {
        id_pais: 184,
        pais: "Tonga",
        sigla: "TO",
        codigo_ibge: "776",
        codigo_bacen: "810",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tonga",
        value: "184"
      },
      {
        id_pais: 296,
        pais: "Toquelau, Ilhas",
        sigla: "TK",
        codigo_ibge: "772",
        codigo_bacen: "805",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Toquelau, Ilhas",
        value: "296"
      },
      {
        id_pais: 185,
        pais: "Trinidad and Tobago",
        sigla: "TT",
        codigo_ibge: "780",
        codigo_bacen: "815",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Trinidad and Tobago",
        value: "185"
      },
      {
        id_pais: 186,
        pais: "Tunisia",
        sigla: "TN",
        codigo_ibge: "788",
        codigo_bacen: "820",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tunísia",
        value: "186"
      },
      {
        id_pais: 275,
        pais: "Turcas e Caicos, Ilhas",
        sigla: "TC",
        codigo_ibge: "796",
        codigo_bacen: "823",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Turcas e Caicos, Ilhas",
        value: "275"
      },
      {
        id_pais: 187,
        pais: "Turcomenistao, República do",
        sigla: "TM",
        codigo_ibge: "795",
        codigo_bacen: "824",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Turcomenistão, República do",
        value: "187"
      },
      {
        id_pais: 188,
        pais: "Turquía",
        sigla: "TR",
        codigo_ibge: "792",
        codigo_bacen: "827",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Turquia",
        value: "188"
      },
      {
        id_pais: 297,
        pais: "Tuvalu",
        sigla: "TV",
        codigo_ibge: "798",
        codigo_bacen: "828",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Tuvalu",
        value: "297"
      },
      {
        id_pais: 190,
        pais: "Ucrânia",
        sigla: "UA",
        codigo_ibge: "804",
        codigo_bacen: "831",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Ucrania",
        value: "190"
      },
      {
        id_pais: 191,
        pais: "Uganda",
        sigla: "UG",
        codigo_ibge: "800",
        codigo_bacen: "833",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Uganda",
        value: "191"
      },
      {
        id_pais: 192,
        pais: "Uruguai",
        sigla: "UY",
        codigo_ibge: "858",
        codigo_bacen: "845",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Uruguai",
        value: "192"
      },
      {
        id_pais: 193,
        pais: "Uzbequistao, República do",
        sigla: "UZ",
        codigo_ibge: "860",
        codigo_bacen: "847",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Uzbequistão, República do",
        value: "193"
      },
      {
        id_pais: 194,
        pais: "Vanuatu",
        sigla: "VU",
        codigo_ibge: "548",
        codigo_bacen: "881",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Vanuatu",
        value: "194"
      },
      {
        id_pais: 298,
        pais: "Vaticano, Est. da Cidade do",
        sigla: "VA",
        codigo_ibge: "336",
        codigo_bacen: "848",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Vaticano, Est. da Cidade do",
        value: "298"
      },
      {
        id_pais: 196,
        pais: "Venezuela",
        sigla: "VE",
        codigo_ibge: "862",
        codigo_bacen: "850",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Venezuela",
        value: "196"
      },
      {
        id_pais: 197,
        pais: "Vietna",
        sigla: "VN",
        codigo_ibge: "704",
        codigo_bacen: "858",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Vietnã",
        value: "197"
      },
      {
        id_pais: 276,
        pais: "Virgens, ilhas (Britanicas)",
        sigla: "VG",
        codigo_ibge: "92",
        codigo_bacen: "863",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Virgens, ilhas (Britânicas)",
        value: "276"
      },
      {
        id_pais: 277,
        pais: "Virgens, Ilhas (E.U.A)",
        sigla: "VI",
        codigo_ibge: "850",
        codigo_bacen: "866",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Virgens, Ilhas (E.U.A)",
        value: "277"
      },
      {
        id_pais: 265,
        pais: "Wake, Ilha",
        sigla: "IW",
        codigo_ibge: null,
        codigo_bacen: null,
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Wake, Ilha",
        value: "265"
      },
      {
        id_pais: 278,
        pais: "Wallis e Futuna, Ilhas",
        sigla: "WF",
        codigo_ibge: "876",
        codigo_bacen: "875",
        created_at: "2021-04-19 16:34:09",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Wallis e Futuna, Ilhas",
        value: "278"
      },
      {
        id_pais: 198,
        pais: "Zambia",
        sigla: "ZM",
        codigo_ibge: "894",
        codigo_bacen: "890",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Zambia",
        value: "198"
      },
      {
        id_pais: 199,
        pais: "Zimbabue",
        sigla: "ZW",
        codigo_ibge: "716",
        codigo_bacen: "665",
        created_at: "2019-01-14 01:00:00",
        updated_at: "2022-09-14 10:06:20",
        vigencia_inicio: null,
        vigencia_fim: null,
        label: "Zimbábue",
        value: "199"
      }
    ]
  },
  id_tipo_ncm: {
    id_tipo_filtro: "14",
    descricao: "tipo aliquota",
    tipo_campo: "select",
    html_id: "id_tipo_ncm",
    dependencia_count: "0",
    valores: []
  },
  id_regra: {
    id_tipo_filtro: "15",
    descricao: "tipo_regra",
    tipo_campo: "select",
    html_id: "id_regra",
    dependencia_count: "0",
    valores: []
  }
};
